import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '../components/loader';
import { Popover, OverlayTrigger, Alert } from 'react-bootstrap';
import ToggleButton from 'react-bootstrap-toggle';
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css';
import {
    encodeSearchParams, decodeSearchParams, getDefaultSearchParams,
    getTextForSearchParameters, getFormattedOptions, getBeds, getBaths,
    getGarages, getHomeSizes, getLotSizes, getBuiltYears, getMaxHOAFees,
    getMinPriceRange, getMaxPriceRange, getMinTLCRange, getMaxTLCRange,
    /* isFiltersSelected, */ getFamilyTypeName, getLoanTypeName,
    getPropertyTypes, getSearchStatuses,
    getWaterFrontTypes, getNeighborhoodItemText, getFormattedValueForReactSelect,
    getFormattedOptionsForReactSelect, getCondoTypes, getStories, getLotFeatures,
    getPropertyStyles, getRooms, getAccessibilities, getEntryDays, IsMLSNumber, 
    IsMultiZip, IsSingleZip, getPropertyCardAdId,
    GetSiteCustomizationOptions, GetSectionCustomizationOptions
} from '../components/util';
import Cookies from 'universal-cookie';
import '../css/Searchbar.css';
import '../scss/_searchbar.scss';
import { ClientPath, AgentPath } from '../components/util';
//import EsriAutoComplete from '../components/esriautocomplete';
//import CustomAutoComplete from 'components/customautocomplete';
import SuperAutoComplete from 'components/superautocomplete';
//import DatePicker from 'react-bootstrap-date-picker';
import SelectBox from '../components/select-box';
import Select from 'react-select';
import '../css/select-box.css';
import base64 from 'base-64';
import utf8 from 'utf8';
import { Link } from 'react-router-dom';
//import RadioGroup from '../components/radiogroup';
import ReactTooltip from 'react-tooltip';
import SmartRange from '../components/smartrange';
import CommutePopup from '../components/commutepopup';
import * as sessionActions from 'actions/session';
import * as profileActions from 'actions/profile';
import * as searchActions from 'actions/search';
import * as clientActions from 'actions/clients';
import * as settingActions from 'actions/settings';
import * as manageActions from 'actions/manage';
import * as L from 'leaflet';
import { GeoLocation } from 'react-redux-geolocation';
//import {MenuItem, DropdownButton } from 'react-bootstrap';
//import { IndexLinkContainer } from 'react-router-bootstrap';
const SiteCustomizationOptions = GetSiteCustomizationOptions();
const ThemeCustomizationOptions = GetSectionCustomizationOptions("ThemeOptions");
const SearchPageCustomizationOptions = GetSectionCustomizationOptions("SearchPageOptions");
const AdminCustomizationOptions = GetSectionCustomizationOptions("AdminOptions");
const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");

class SearchBar extends Component {

    constructor(props) {
        super(props);
        
        var isLocationSearch = false;
        var searchByParam = "place";
        var searchURLParams = props.searchURLParams;
        if (searchURLParams) {
            searchURLParams = decodeSearchParams(searchURLParams);
            if (searchURLParams.mapbound) {
                searchURLParams.mapbound = utf8.decode(base64.decode(searchURLParams.mapbound));
            }

            window.sessionStorage.setItem("SearchURLParams", true);
        }
        else {
            var storedParams = this.props.searchParameters_Redux;
            if (storedParams) {
                searchURLParams = storedParams;

                //Set Default---
                //searchURLParams.baths = "2g";
                //searchURLParams.beds = "4g";
                //searchURLParams.listingpricemin = 200000;
                //searchURLParams.location = ["Buffalo, NY, USA"];
                //-----

                if (searchURLParams && searchURLParams.location && searchURLParams.location !== '' && Array.isArray(searchURLParams.location) && searchURLParams.location.length > 0) {
                    searchURLParams.location = searchURLParams.location[0];
                }

                /* if (searchURLParams && searchURLParams.MLSNumber && searchURLParams.MLSNumber !== '' && searchURLParams.MLSNumber.length > 0) {
                    if (searchURLParams.MLSNumber[0].indexOf('#') === -1) {
                        //searchURLParams.MLSNumber = "#" + searchURLParams.MLSNumber[0];
                        searchURLParams.MLSNumber = searchURLParams.MLSNumber[0];
                    }
                    else {
                        searchURLParams.MLSNumber = searchURLParams.MLSNumber[0];
                    }
                } */
            }
        }

        var locationText = "";
        if (searchURLParams && searchURLParams.location && searchURLParams.location !== '') {
            locationText = searchURLParams.location;
            searchByParam = "place";
            isLocationSearch = true;
        }
        else if (searchURLParams && searchURLParams.MLSNumber && 
        ((!Array.isArray(searchURLParams.MLSNumber) && searchURLParams.MLSNumber !== '') || 
        (Array.isArray(searchURLParams.MLSNumber) && searchURLParams.MLSNumber.length > 0 && searchURLParams.MLSNumber[0] !== ''))) {
            locationText = (Array.isArray(searchURLParams.MLSNumber) && searchURLParams.MLSNumber.length > 0) ? searchURLParams.MLSNumber[0] : searchURLParams.MLSNumber;
            searchByParam = "mls";
        }
        /* else if (searchURLParams && searchURLParams.MLSNumber && searchURLParams.MLSNumber !== '') {
            if (searchURLParams.MLSNumber.indexOf('#') === -1) {
                //locationText = "#" + searchURLParams.MLSNumber;
                locationText = searchURLParams.MLSNumber;
            }
            else {
                locationText = searchURLParams.MLSNumber;
            }
            searchByParam = "mls";
        } */
        if (searchURLParams && searchURLParams.locationtext && searchURLParams.locationtext !== '') {
            locationText = searchURLParams.locationtext;
            isLocationSearch = true;
        }

        if (searchURLParams && searchURLParams.neighborhood && searchURLParams.neighborhood !== '' && !Array.isArray(searchURLParams.neighborhood)) {
            searchURLParams.neighborhood = searchURLParams.neighborhood.split(',');
        }
        /* if(searchURLParams && searchURLParams.regionalboardcode && searchURLParams.regionalboardcode !== '' && !Array.isArray(searchURLParams.regionalboardcode)){
            searchURLParams.regionalboardcode = searchURLParams.regionalboardcode.split(',');
        } */
        if (searchURLParams && searchURLParams.lotfeature && searchURLParams.lotfeature !== '' && !Array.isArray(searchURLParams.lotfeature)) {
            searchURLParams.lotfeature = searchURLParams.lotfeature.split(',');
        }
        if (searchURLParams && searchURLParams.propertystyle && searchURLParams.propertystyle !== '' && !Array.isArray(searchURLParams.propertystyle)) {
            searchURLParams.propertystyle = searchURLParams.propertystyle.split(',');
        }
        if (searchURLParams && searchURLParams.roompref && searchURLParams.roompref !== '' && !Array.isArray(searchURLParams.roompref)) {
            searchURLParams.roompref = searchURLParams.roompref.split(',');
        }
        if (searchURLParams && searchURLParams.accessibility && searchURLParams.accessibility !== '' && !Array.isArray(searchURLParams.accessibility)) {
            searchURLParams.accessibility = searchURLParams.accessibility.split(',');
        }        
        if(searchURLParams && searchURLParams.homeFeatures && searchURLParams.homeFeatures !== '' && !Array.isArray(searchURLParams.homeFeatures)){
            searchURLParams.homeFeatures = searchURLParams.homeFeatures.split(',');
        }
        if (searchURLParams && searchURLParams.propertytype && searchURLParams.propertytype !== '' && !Array.isArray(searchURLParams.propertytype)) {
            searchURLParams.propertytype = searchURLParams.propertytype.split(',');
        }
        else{
            if(CommonCustomizationOptions && CommonCustomizationOptions.DefaultSearchPropertyTypes && 
                CommonCustomizationOptions.DefaultSearchPropertyTypes !== "" && !window.sessionStorage.getItem("ReturnedFromPropDetail")){
                searchURLParams.propertytype = CommonCustomizationOptions.DefaultSearchPropertyTypes.split(',');
            }
        }        

        //var defaultParameters = getDefaultSearchParams();
        //var searchParameters = Object.assign({}, defaultParameters, searchURLParams);

        var searchParameters = Object.assign({}, {}, searchURLParams);

        /* if (searchParameters && searchParameters["location"]) {
            delete searchParameters["location"];
        } */

        /* if (searchParameters && searchParameters["MLSNumber"]) {
            delete searchParameters["MLSNumber"];
        } */

        /* if (locationText !== "" || (searchParameters.commuteaddress && searchParameters.commuteaddress !== "")) {
            //delete searchParameters["mapbound"];
        } */

        this.state = {
            locationText: locationText,
            isLocationSearch: isLocationSearch,
            searchByParam: searchByParam,
            fetchingResult: false,
            showMap: false,
            moreFilterState: false,
            saveSearchNameRequiredNotification: true,
            showNearbySearch: false,
            recentSearches: [],
            recentSearchClicked: false,
            askGeoLocation: false,
            mSearchExpanded: false
        };
        this.onLocationTextChange = this.onLocationTextChange.bind(this);
        this.onLocationTextClear = this.onLocationTextClear.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
        this.onSaveSearch = this.onSaveSearch.bind(this);
        this.openSaveSearch = this.openSaveSearch.bind(this);
        this.saveSearchNameChange = this.saveSearchNameChange.bind(this);
        this.saveSearchNameNotificationChange = this.saveSearchNameNotificationChange.bind(this);
        this.saveSearchKeyDown = this.saveSearchKeyDown.bind(this);
        this.handleAutoComplete = this.handleAutoComplete.bind(this);
        this.handleAutoCompleteBlur = this.handleAutoCompleteBlur.bind(this);
        this.doSearch = this.doSearch.bind(this);
        this.handleOHEndDate = this.handleOHEndDate.bind(this);
        this.handleOHStartDate = this.handleOHStartDate.bind(this);

        this.workingWithClient = this.workingWithClient.bind(this);
        this.setupTLCParams = this.setupTLCParams.bind(this);

        this.onBlurEvent = this.onBlurEvent.bind(this);

        this.onMoreFilterClick = this.onMoreFilterClick.bind(this);

        this.handleGarageChange = this.handleGarageChange.bind(this);
        this.handleHomeSizeChange = this.handleHomeSizeChange.bind(this);
        this.handleLotSizeChange = this.handleLotSizeChange.bind(this);
        this.handleAgeChange = this.handleAgeChange.bind(this);

        this.handleBedsChange = this.handleBedsChange.bind(this);
        this.handleBathChange = this.handleBathChange.bind(this);
        this.handlePropertyTypeChange = this.handlePropertyTypeChange.bind(this);

        this.handleMaxHOAFeeChange = this.handleMaxHOAFeeChange.bind(this);
        this.handleRadioValueChange = this.handleRadioValueChange.bind(this);

        this.handlePriceRangeValueChange = this.handlePriceRangeValueChange.bind(this);
        this.handleTLCRangeValueChange = this.handleTLCRangeValueChange.bind(this);

        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.IsFilterWithInMapDefault && !window.sessionStorage.getItem("ReturnedFromPropDetail")){
            searchParameters.searchmap = "true";
        }
        window.sessionStorage.removeItem("ReturnedFromPropDetail");

        //var rParams = Object.assign({}, searchParameters, locationText !== "" ? { locationtext: locationText } : {});
        var rParams = Object.assign({}, searchParameters);
        this.nearbyButton = null;

        if (JSON.stringify(rParams) !== JSON.stringify(this.props.searchParameters_Redux)) {
            this.props.searchActions.updateParameters(rParams);
        }

    }

    componentDidMount() {
        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchNeighborhoodsList){
            this.props.settingActions.fetchBaseData('neighborhoods', {});
        }
        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchSchoolDistrictsList){
            this.props.settingActions.fetchBaseData('schooldistrictnames', {});
        }

        if (!this.props.searchURLParams && this.props.audience && ((this.props.audience.type === "agent" && this.props.selectedClient) || this.props.audience.type === "client")) {
            this.workingWithClient(this.props.selectedClient, this.props.profile);
        }
        else {
            this.doSearch(this.props.searchParameters_Redux);
        }

        var self = this;
        setTimeout(function isProfileLoaded() {
            if (!self.props.profile) {
                setTimeout(isProfileLoaded, 1000);
            }
            else {
                self.getRecentSearches();
            }
        }, 1000);

        window.onpopstate = this.handlePopState;

        if (window.sessionStorage.getItem("OpenAdvancedSearch") && window.sessionStorage.getItem("OpenAdvancedSearch") === "true") {
            this.setState({ moreFilterState: true });
            window.sessionStorage.removeItem("OpenAdvancedSearch");
        }
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.searchParameters_Redux) !== JSON.stringify(nextProps.searchParameters_Redux)) {
            /* if ((nextProps.searchParameters_Redux.locationtext === undefined ||
                nextProps.searchParameters_Redux.locationtext === null) && this.state.locationText !== "") {
                this.setState({ locationText: "" });
                if (this.esriAutoComplete && this.esriAutoComplete.getWrappedInstance() && this.esriAutoComplete.getWrappedInstance().clear) {
                    this.esriAutoComplete.getWrappedInstance().clear();
                }
            }
            else if (nextProps.searchParameters_Redux.locationtext !== undefined &&
                nextProps.searchParameters_Redux.locationtext !== null &&
                nextProps.searchParameters_Redux.locationtext !== this.state.locationText) {
                this.setState({ locationText: nextProps.searchParameters_Redux.locationtext ? nextProps.searchParameters_Redux.locationtext : "" });
            } */            
            if(window.sessionStorage.getItem("ClearLocationText","true")){
                window.sessionStorage.removeItem("ClearLocationText");
                this.setState({ locationText: "", isLocationSearch: false }, () => {
                    if (this.esriAutoComplete && this.esriAutoComplete.getWrappedInstance() && this.esriAutoComplete.getWrappedInstance().clear) {
                        this.esriAutoComplete.getWrappedInstance().clear();

                        this.doSearch(nextProps.searchParameters_Redux);
                    }
                });                
            }
            else{
                this.doSearch(nextProps.searchParameters_Redux);
            }            
        }

        if ((((this.props.selectedClient === undefined || this.props.selectedClient === null)
            && (nextProps.selectedClient !== undefined && nextProps.selectedClient !== null)) ||
            ((this.props.selectedClient !== undefined && this.props.selectedClient !== null)
                && (nextProps.selectedClient === undefined || nextProps.selectedClient === null))) ||
            (this.props.profile === null && nextProps.profile !== null)) {
            this.workingWithClient(nextProps.selectedClient, nextProps.profile);
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.geolocation) !== JSON.stringify(prevProps.geolocation)) {
            if (!this.props.geolocation.error) {
                if (this.nearbyButton.id === 'openHouses')
                    this.getGeoOpenHouses();
                else
                    this.getGeoLocation();
            }
            else
                this.setState({ showNearbySearch: false, askGeoLocation: false })
        }
        else if (JSON.stringify(this.props.selectedClient) !== JSON.stringify(prevProps.selectedClient)) {
            this.getRecentSearches()
        }
    }

    componentWillUnmount() {
        window.onpopstate = () => { };
    }

    handlePopState = (event) => {
        if (event && event.state && event.state.searchParams) {
            //variable used to manage url push state
            window.sessionStorage.setItem("PreventSearchURLUpdate", true);
            var locText = "";
            var sparams = event.state.searchParams;
            if (sparams.location) {
                if (sparams.location.length > 0){
                    //sparams.locationtext = sparams.location[0];
                    locText = sparams.location[0];
                }
                else {
                    //sparams.locationtext = sparams.location;
                    locText = sparams.location;
                }
                //delete sparams["location"];
            }
            if (sparams.MLSNumber) {
                if (Array.isArray(sparams.MLSNumber) && sparams.MLSNumber.length > 0) {
                    //sparams.locationtext = sparams.MLSNumber[0];
                    locText = sparams.MLSNumber[0];
                }
                else {
                    //sparams.locationtext = sparams.MLSNumber;
                    locText = sparams.MLSNumber;
                }
                //delete sparams["MLSNumber"];
            }
            if (sparams.mapbound) {
                sparams.mapbound = utf8.decode(base64.decode(sparams.mapbound));
            }
            if (sparams.neighborhood && sparams.neighborhood !== "" && !Array.isArray(sparams.neighborhood)) {
                sparams.neighborhood = sparams.neighborhood.split(',');
            }
            if (sparams.lotfeature && sparams.lotfeature !== "" && !Array.isArray(sparams.lotfeature)) {
                sparams.lotfeature = sparams.lotfeature.split(',');
            }
            if (sparams.propertystyle && sparams.propertystyle !== "" && !Array.isArray(sparams.propertystyle)) {
                sparams.propertystyle = sparams.propertystyle.split(',');
            }
            if (sparams.roompref && sparams.roompref !== "" && !Array.isArray(sparams.roompref)) {
                sparams.roompref = sparams.roompref.split(',');
            }
            if (sparams.accessibility && sparams.accessibility !== "" && !Array.isArray(sparams.accessibility)) {
                sparams.accessibility = sparams.accessibility.split(',');
            }
            if (sparams.propertytype && sparams.propertytype !== "" && !Array.isArray(sparams.propertytype)) {
                sparams.propertytype = sparams.propertytype.split(',');
            }
            //this.setState({ locationText: sparams.locationtext ? sparams.locationtext : "" });
            this.setState({ locationText: locText });
            this.props.searchActions.updateParameters(sparams);
        }
        else {
            //variable used to manage url push state
            window.sessionStorage.removeItem("PreventSearchURLUpdate");
            window.history.back();
        }
    }

    onChangeView() {
        this.props.onChangeView(this.state.showMap);
        if (this.refs.searchBarRef) {
            this.setState({ showMap: !this.state.showMap, moreFilterState: false });
        }
    }    

    handleOHStartDate(date, fDate) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        var name = 'openhousefromdate';
        parameters[name] = date;

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleOHEndDate(date, fDate) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        var name = 'openhousetodate';
        parameters[name] = date;

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleValueChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (value && value !== "") {
            parameters[name] = value;
        }
        else {
            delete parameters[name];
        }

        if (parameters.openHouseOnly !== undefined && parameters.openHouseOnly) {
            var todayDate = new Date();
            parameters['openhousefromdate'] = todayDate.toISOString();
            parameters['openhousetodate'] = new Date(todayDate.setDate(todayDate.getDate() + 8)).toISOString();
        } else {
            delete parameters['openhousefromdate'];
            delete parameters['openhousetodate'];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handlePriceRangeValueChange(min, max) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;
        if (parameters.listingpricemin !== min || parameters.listingpricemax !== max) {
            if (min && min !== "") {
                parameters["listingpricemin"] = min;
                delete parameters["tlcmin"];
                delete parameters["tlcmax"];
            }
            else {
                delete parameters["listingpricemin"];
            }
            if (max && max !== "") {
                parameters["listingpricemax"] = max;
                delete parameters["tlcmin"];
                delete parameters["tlcmax"];
            }
            else {
                delete parameters["listingpricemax"];
            }

            if (this.refs.searchBarRef) {
                this.props.searchActions.updateParameters(parameters);
            }
        }

    }

    handleTLCRangeValueChange(min, max) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;
        if (parameters.tlcmin !== min || parameters.tlcmax !== max) {
            if (min && min !== "") {
                parameters["tlcmin"] = min;
                delete parameters["listingpricemin"];
                delete parameters["listingpricemax"];
            }
            else {
                delete parameters["tlcmin"];
            }
            if (max && max !== "") {
                parameters["tlcmax"] = max;
                delete parameters["listingpricemin"];
                delete parameters["listingpricemax"];
            }
            else {
                delete parameters["tlcmax"];
            }

            if (this.refs.searchBarRef) {
                this.props.searchActions.updateParameters(parameters);
            }
        }

    }

    handleGarageChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (val && val !== "") {
            parameters["garages"] = val;
        }
        else {
            delete parameters["garages"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }

    }

    handleHomeSizeChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (val && val !== "") {
            parameters["livingareamin"] = val;
        }
        else {
            delete parameters["livingareamin"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleLotSizeChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (val && val !== "") {
            parameters["acresmin"] = val;
        }
        else {
            delete parameters["acresmin"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleAgeChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (val && val !== "") {
            parameters["yearbuiltmin"] = val;
        }
        else {
            delete parameters["yearbuiltmin"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleBedsChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;
        if (val && val !== "") {
            parameters["beds"] = val;
        }
        else {
            delete parameters["beds"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleBathChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;
        if (val && val !== "") {
            parameters["baths"] = val;
        }
        else {
            delete parameters["baths"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handlePropertyTypeChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;
        if (val && val !== "" && (!Array.isArray(val) || (Array.isArray(val) && val.length > 0))) {
            parameters["propertytype"] = val;
        }
        else {
            delete parameters["propertytype"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleReactSelectChange = (val, name) => {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;
        if (val && ((Array.isArray(val) && val.length > 0) || (!Array.isArray(val) && val.value && val.value !== ""))) {
            if (Array.isArray(val)) {
                var aVal = [];
                val.map(item => { aVal.push(item.value); return null; });
                parameters[name] = aVal;
                if (name === "neighborhood") {
                    delete parameters["schooldistrictname"];
                    if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchSchoolDistrictsList){
                        this.props.settingActions.fetchBaseData('schooldistrictnames', { neighborhood: aVal.join(',') });
                    }
                }
            }
            else {
                parameters[name] = val.value;
                if (name === "neighborhood") {
                    delete parameters["schooldistrictname"];
                    if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchSchoolDistrictsList){
                        this.props.settingActions.fetchBaseData('schooldistrictnames', { neighborhood: val.value });
                    }
                }
            }
        }
        else {
            delete parameters[name];
            if (name === "neighborhood") {
                delete parameters["schooldistrictname"];
                if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchSchoolDistrictsList){
                    this.props.settingActions.fetchBaseData('schooldistrictnames', {});
                }
            }
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleMaxHOAFeeChange(val) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (val && val !== "") {
            parameters["hoafeemax"] = val;
        }
        else {
            delete parameters["hoafeemax"];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    getGeoLocation = (e) => {
        if (this.hasGeoLocation()) {
            const { geolocation, searchParameters_Redux } = this.props;
            const geochords = { 'geochords': `${geolocation.longitude},${geolocation.latitude}` };
            delete searchParameters_Redux["mapbound"];
            this.props.searchActions.updateParameters({ ...searchParameters_Redux, ...geochords });
            this.setState({ showNearbySearch: false })
        }
        else {
            this.nearbyButton = e.target;
            e.preventDefault();
        }
    }

    getGeoOpenHouses = (e) => {
        if (this.hasGeoLocation()) {
            const { geolocation, searchParameters_Redux } = this.props;
            const geochords = { 'geochords': `${geolocation.longitude},${geolocation.latitude}` };
            var today = new Date();
            var openHouse = {
                openHouseOnly: true,
                openhousefromdate: today.toISOString(),
                openhousetodate: new Date(today.setDate(today.getDate() + 8)).toISOString()
            }
            delete searchParameters_Redux["mapbound"];
            this.props.searchActions.updateParameters({ ...searchParameters_Redux, ...geochords, ...openHouse });
            this.setState({ showNearbySearch: false })
        }
        else {
            this.nearbyButton = e.target;
            e.preventDefault();
        }
    }

    hasGeoLocation = () => {
        const { geolocation } = this.props;
        if (geolocation && geolocation.latitude) {
            this.setState({ askGeoLocation: false })
            return true;
        }
        else {
            this.setState({ askGeoLocation: true })
            return false;
        }
    }

    handleRadioValueChange(e) {
        if (e) {
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            if (e.target.value && e.target.value !== "") {
                parameters[e.target.name] = e.target.value;
            }
            else {
                delete parameters[e.target.name];
            }

            if (this.refs.searchBarRef) {
                this.props.searchActions.updateParameters(parameters);
            }
        }
    }

    onBlurEvent(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (value && value !== "") {
            parameters[name] = value;
        }
        else {
            delete parameters[name];
        }

        if (parameters.openHouseOnly !== undefined && parameters.openHouseOnly) {
            var todayDate = new Date();
            parameters['openhousefromdate'] = todayDate.toISOString();
            parameters['openhousetodate'] = new Date(todayDate.setDate(todayDate.getDate() + 8)).toISOString();
        } else {
            delete parameters['openhousefromdate'];
            delete parameters['openhousetodate'];
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    resetSearch() {
        var self = this;
        if (self.keywordsRef) self.keywordsRef.value = "";
        if (self.postalCodeRef) self.postalCodeRef.value = "";
        self.setState({ locationText: "", isLocationSearch: false }, () => {
            self.clearAutoComplete();
            var df = {};
            if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.IsFilterWithInMapDefault){
                df.searchmap = "true";
            }
            if(CommonCustomizationOptions && CommonCustomizationOptions.DefaultSearchPropertyTypes && 
                CommonCustomizationOptions.DefaultSearchPropertyTypes !== ""){
                df.propertytype = CommonCustomizationOptions.DefaultSearchPropertyTypes.split(',');                
            }
            self.props.searchActions.resetParameters(df);
        });        
    }

    onSearch(event) {
        //console.log('In SearchBar: onSearch');
        if (event) event.preventDefault();
        this.processAutoComplete();
        this.doSearch();
    }

    doSearch(params) {
        //console.log('In SearchBar: doSearch');

        var self = this;
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        /*parameters.page_number = 1;
        parameters.skip=0;*/

        if (params !== undefined) {
            parameters = Object.assign({}, params);
        }

        //console.log('doSearch parameters:');
        //console.log(JSON.stringify(parameters));

        /* if (parameters.locationtext && parameters.locationtext !== "" && this.state.isLocationSearch &&
        (!parameters.MLSNumber || (parameters.MLSNumber && parameters.MLSNumber[0] !== parameters.locationtext))) {

            if (IsMLSNumber(parameters.locationtext)) {
                parameters.MLSNumber = [];
                parameters.MLSNumber.push(parameters.locationtext.replace('#', ''));
                window.sessionStorage.setItem("RemoveMapboundSearchParameter", true);
            }
            else {
                parameters.location = [];
                parameters.location.push(parameters.locationtext);
            }

            delete parameters["addresses"];

            if (window.sessionStorage.getItem("RemoveMapboundSearchParameter")) {
                delete parameters["mapbound"];
                window.sessionStorage.removeItem("RemoveMapboundSearchParameter");
            }
        }

        if (parameters.locationtext === undefined || parameters.locationtext === null || parameters.locationtext === "") {
            delete parameters["place"];
            delete parameters["PlaceSearch"];
            delete parameters["location"];
            //delete parameters["MLSNumber"];
        }
        delete parameters["locationtext"]; */

        if (this.state.locationText && this.state.locationText !== "" && this.state.isLocationSearch) {

            if(IsMultiZip(this.state.locationText)){
                parameters.postalcode = this.state.locationText.trim().replace(/(^,)|(,$)/g, "").replace(/ /g,"");
            }
            else if(IsSingleZip(this.state.locationText)){
                parameters.postalcode = this.state.locationText.trim();
            }
            else if(IsMLSNumber(this.state.locationText)){
                parameters.MLSNumber = [];
                parameters.MLSNumber.push(this.state.locationText);
                window.sessionStorage.setItem("RemoveMapboundSearchParameter", true);
            }
            else{
                parameters.location = [];
                parameters.location.push(this.state.locationText);
            }

            delete parameters["addresses"];

            if (window.sessionStorage.getItem("RemoveMapboundSearchParameter")) {
                delete parameters["mapbound"];
                window.sessionStorage.removeItem("RemoveMapboundSearchParameter");
            }
        }

        delete parameters["place"];
        delete parameters["PlaceSearch"];        

        if (!parameters.openHouseOnly) {
            delete parameters["openhousefromdate"];
            delete parameters["openhousetodate"];
        }

        if (parameters.neighborhood && parameters.neighborhood.length > 0 && Array.isArray(parameters.neighborhood)) {
            parameters.neighborhood = parameters.neighborhood.join(',');
        }
        /* else if(parameters.neighborhood && parameters.neighborhood !== "" && !Array.isArray(parameters.neighborhood)){
            parameters.neighborhood = parameters.neighborhood;
        } */
        else {
            delete parameters["neighborhood"];
        }
        /* if(parameters.regionalboardcode && parameters.regionalboardcode.length > 0 && Array.isArray(parameters.regionalboardcode)){
            parameters.regionalboardcode = parameters.regionalboardcode.join(',');
        }
        else{
            delete parameters["regionalboardcode"];
        } */
        if (parameters.lotfeature && parameters.lotfeature.length > 0 && Array.isArray(parameters.lotfeature)) {
            parameters.lotfeature = parameters.lotfeature.join(',');
        }
        else {
            delete parameters["lotfeature"];
        }
        if (parameters.propertystyle && parameters.propertystyle.length > 0 && Array.isArray(parameters.propertystyle)) {
            parameters.propertystyle = parameters.propertystyle.join(',');
        }
        else {
            delete parameters["propertystyle"];
        }
        if (parameters.roompref && parameters.roompref.length > 0 && Array.isArray(parameters.roompref)) {
            parameters.roompref = parameters.roompref.join(',');
        }
        else {
            delete parameters["roompref"];
        }
        if (parameters.accessibility && parameters.accessibility.length > 0 && Array.isArray(parameters.accessibility)) {
            parameters.accessibility = parameters.accessibility.join(',');
        }
        else {
            delete parameters["accessibility"];
        }
        if (parameters.propertytype && parameters.propertytype.length > 0 && Array.isArray(parameters.propertytype)) {
            parameters.propertytype = parameters.propertytype.join(',');
        }
        if (parameters.streetaddress && parameters.streetaddress.length > 0 && Array.isArray(parameters.streetaddress)) {
            parameters.streetaddress = parameters.streetaddress.join(',');
        }
        if (parameters.city && parameters.city.length > 0 && Array.isArray(parameters.city)) {
            parameters.city = parameters.city.join(',');
        }
        if (parameters.postalcode && parameters.postalcode.length > 0 && Array.isArray(parameters.postalcode)) {
            parameters.postalcode = parameters.postalcode.join(',');
        }        

        let encodedParameters = Object.assign({}, parameters);
        /*delete encodedParameters["skip"];*/
        delete encodedParameters["limitrecords"];
        delete encodedParameters["ficoscore"];
        delete encodedParameters["loantype"];
        delete encodedParameters["lifestyle"];
        delete encodedParameters["cpolygon"];
        delete encodedParameters["pagechange"];
        if (encodedParameters.mapbound) {
            encodedParameters.mapbound = base64.encode(utf8.encode(encodedParameters.mapbound));
        }
        //window.history.replaceState({searchParams: encodedParameters},"","/search/" + encodeSearchParams(encodedParameters));
        if (!window.sessionStorage.getItem("PreventSearchURLUpdate")) {
            window.history.pushState({ searchParams: encodedParameters }, "", `${this.props.purlPrefix.url}/search/?` + encodeSearchParams(encodedParameters));
        }
        else {
            window.sessionStorage.removeItem("PreventSearchURLUpdate");
        }

        /* if(parameters.stories && parameters.stories !== ""){
            if(parameters.stories.toLowerCase().replace(/ /g,'') === "singlestory"){
                parameters.storiesexact = 1;
                delete parameters["storiesmin"];
            }
            else if(parameters.stories.toLowerCase().replace(/ /g,'') === "greaterthansinglestory"){
                parameters.storiesmin = 2;
                delete parameters["storiesexact"];
            }
            delete parameters["stories"];
        }
        else{
            delete parameters["stories"];
            delete parameters["storiesexact"];
            delete parameters["storiesmin"];
        }

        if(parameters.neighborhood && parameters.neighborhood !== ""){
            parameters.neighborhood = getNeighborhoodItemText(parameters.neighborhood).split(', ').join(',');
        }

        if(!parameters.status || parameters.status === ""){
            if(SiteCustomizationOptions && SiteCustomizationOptions.DefaultStatuses && SiteCustomizationOptions.DefaultStatuses !== ""){
                parameters.status = SiteCustomizationOptions.DefaultStatuses;
            }
        }
        if(parameters.MLSNumber && Array.isArray(parameters.MLSNumber) && parameters.MLSNumber.length > 0){
            if(SiteCustomizationOptions && SiteCustomizationOptions.DefaultPropertyTypes && SiteCustomizationOptions.DefaultPropertyTypes !== ""){
                parameters.propertytype = SiteCustomizationOptions.DefaultPropertyTypes;
            }
        } */

        //ignore previous skip when doing a new search
        if (parameters.pagechange) {
            delete parameters["pagechange"];
        }
        else {
            //delete parameters["skip"];
        }

        var parametersToBePassed = Object.assign({}, parameters);
        if (parametersToBePassed.place !== undefined && parametersToBePassed.place !== null) {
            delete parametersToBePassed["location"];
            delete parametersToBePassed["MLSNumber"];
        }

        if (parametersToBePassed.polygon && (parametersToBePassed.polygon.length === 0 || parametersToBePassed.polygon[0] === "")) {
            delete parametersToBePassed['polygon'];
        }

        if (parametersToBePassed.mapbound && parametersToBePassed.mapbound !== "") {
            var bnds = parametersToBePassed.mapbound.split(",");
            parametersToBePassed.mapbound = bnds[0] + " " + bnds[1] +
                "," + bnds[2] + " " + bnds[1] + "," + bnds[2] + " " + bnds[3] +
                "," + bnds[0] + " " + bnds[3] + "," + bnds[0] + " " + bnds[1];
        }
        else if (parametersToBePassed.geochords) {
            // create bounds around geo chords, and then put it in a string to send like mapbound
            var split = parametersToBePassed.geochords.split(',');
            var bounds = L.latLng(split[1], split[0]).toBounds(2000);
            var boundsFromGeo = bounds._northEast.lng + ',' + bounds._northEast.lat + ',' + bounds._southWest.lng + ',' + bounds._southWest.lat;
            var bndsStr = boundsFromGeo.split(",");
            parametersToBePassed.mapbound = bndsStr[0] + " " + bndsStr[1] +
                "," + bndsStr[2] + " " + bndsStr[1] + "," + bndsStr[2] + " " + bndsStr[3] +
                "," + bndsStr[0] + " " + bndsStr[3] + "," + bndsStr[0] + " " + bndsStr[1];
        }

        if (parametersToBePassed.commuteaddress && parametersToBePassed.commuteaddress !== "") {
            parametersToBePassed.commutes = [{
                commuteaddress: parametersToBePassed.commuteaddress,
                commutemode: "car",
                commutetimemins: parametersToBePassed.commutetimemins && parametersToBePassed.commutetimemins !== "" ? parametersToBePassed.commutetimemins : "45"
            }];
            delete parametersToBePassed["commuteaddress"];
            delete parametersToBePassed["commutetimemins"];
        }

        if (parametersToBePassed.stories && parametersToBePassed.stories !== "") {
            if (parametersToBePassed.stories.toLowerCase().replace(/ /g, '') === "singlestory") {
                parametersToBePassed.storiesexact = 1;
                delete parametersToBePassed["storiesmin"];
            }
            else if (parametersToBePassed.stories.toLowerCase().replace(/ /g, '') === "greaterthansinglestory") {
                parametersToBePassed.storiesmin = 2;
                delete parametersToBePassed["storiesexact"];
            }
            delete parametersToBePassed["stories"];
        }
        else {
            delete parametersToBePassed["stories"];
            delete parametersToBePassed["storiesexact"];
            delete parametersToBePassed["storiesmin"];
        }

        if (parametersToBePassed.neighborhood && parametersToBePassed.neighborhood !== "") {
            parametersToBePassed.neighborhood = getNeighborhoodItemText(parametersToBePassed.neighborhood).split(', ').join(',');
        }

        if (!parametersToBePassed.status || parametersToBePassed.status === "") {
            if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultStatuses && CommonCustomizationOptions.DefaultStatuses !== "") {
                parametersToBePassed.status = CommonCustomizationOptions.DefaultStatuses;
            }
        }
        if ((parametersToBePassed.streetaddress && parametersToBePassed.streetaddress !== "")) {
            if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultPropertyTypes && CommonCustomizationOptions.DefaultPropertyTypes !== "") {
                parametersToBePassed.propertytype = CommonCustomizationOptions.DefaultPropertyTypes;
            }
            if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultAutoSuggestStatuses && CommonCustomizationOptions.DefaultAutoSuggestStatuses !== "") {
                parametersToBePassed.status = CommonCustomizationOptions.DefaultAutoSuggestStatuses;
            }
        }
        if (parametersToBePassed.MLSNumber && !Array.isArray(parametersToBePassed.MLSNumber)) {
            parametersToBePassed.MLSNumber = [parametersToBePassed.MLSNumber];
        }
        if (parametersToBePassed.MLSNumber && Array.isArray(parametersToBePassed.MLSNumber) && parametersToBePassed.MLSNumber.length > 0) {
            if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultPropertyTypes && CommonCustomizationOptions.DefaultPropertyTypes !== "") {
                parametersToBePassed.propertytype = CommonCustomizationOptions.DefaultPropertyTypes;
            }
            if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultAutoSuggestStatuses && CommonCustomizationOptions.DefaultAutoSuggestStatuses !== "") {
                parametersToBePassed.status = CommonCustomizationOptions.DefaultAutoSuggestStatuses;
            }
        }
        if (parametersToBePassed.location && Array.isArray(parametersToBePassed.location) && parametersToBePassed.location.length > 0) {
            parametersToBePassed.location = parametersToBePassed.location.map(l => l = l.replace('-City', '').replace('-city', '').replace('-Town', '').replace('-town', ''));
        }
        else if (parametersToBePassed.location && !Array.isArray(parametersToBePassed.location)) {
            parametersToBePassed.location = [parametersToBePassed.location];
        }
        if (parametersToBePassed.exteriorhomestyle && parametersToBePassed.exteriorhomestyle !== "") {
            parametersToBePassed.exteriorhomestyle = [parametersToBePassed.exteriorhomestyle];
        }
        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchListingsWithPhotosOnly){		
            if(!parametersToBePassed.MLSNumber && !parametersToBePassed.streetaddress){		
                parametersToBePassed.listingwithphotoonly = 1;
            }            		
        }		
        if(SiteCustomizationOptions && SiteCustomizationOptions.SearchListingsWithZeroOrMorePhotos){		
            parametersToBePassed.listingwithzeroorphoto = 1;		
        }

        if (self.state.sClient)
            parametersToBePassed.selectedClientId = self.state.sClient.Id;

        // Only return the last search
        var thisSearchId = window.lastSearchId;
        if (thisSearchId === undefined)
            thisSearchId = 0;
        else
            thisSearchId++;
        window.lastSearchId = thisSearchId;

        var url = window.sessionStorage.getItem("RootAPI") + "listingsdata";
        if (self.refs.searchBarRef) {
            self.setState({ fetchingResult: true });
        }
        fetch(url,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
                },
                method: "POST",
                body: JSON.stringify(parametersToBePassed)
            })
            .then(response => response.json())
            .then(json => {

                if (thisSearchId !== window.lastSearchId) {
                    console.log('Delayed Search Result: expected ' + thisSearchId + ' received ' + window.lastSearchId);
                    return;
                }

                //console.log('Expected Search Result: expected ' + thisSearchId + ' received '+ window.lastSearchId);

                //variable used to manage url push state
                window.sessionStorage.removeItem("PreventSearchURLUpdate");

                //window.sessionStorage.setItem("SearchParameters", JSON.stringify(parameters));
                if (self.refs.searchBarRef) {
                    self.setState({ fetchingResult: false });
                }
                if (self.props.onSearch) {
                    self.props.onSearch(parameters, json, self.state.commuteLocation, self.state.sClient);
                }

                if(AdminCustomizationOptions && AdminCustomizationOptions.AllowAdsManagement){
                    if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowCustomAds){
                        //self.props.manageActions.fetchFrontEndAds("searchpageads",getPropertyCardAdId(),1);
                        var adObj = {ads:[]};
                        adObj.ads.push({adsize: getPropertyCardAdId(), count: 2});
                        self.props.manageActions.fetchFrontEndAds("searchpageads", adObj);
                    }
                }
            })
            .catch(function (data) {
                console.log(data);
                if (self.refs.searchBarRef) {
                    self.setState({ fetchingResult: true });
                }
            });
    }

    onSaveSearch() {
        var self = this;

        const { isAnonymous } = this.props;
        if (isAnonymous) {
            // This is not showing right now
            if (this.props.showNotification) {
                this.props.showNotification(
                    "info",
                    "",
                    'You need to login to use this feature',
                    5000,
                    "Cancel",
                    null,
                    null,
                    "Login",
                    this.props.goToLogin
                );
            }
        }
        else {

            const cookies = new Cookies();
            var authToken = cookies.get('authDetails');
            window.authToken = authToken;
            //var selClient = window.sessionStorage.getItem('SelectedClient');
            var selClient = this.props.selectedClient;
            var curAudiencePath = window.sessionStorage.getItem("APIAudience");
            var curAudienceID = authToken.Audience.Id;
            var saveSearchUrl = '';
            if (selClient !== undefined && selClient !== null) {
                //var curSelectedClient = JSON.parse(selClient);
                var curSelectedClient = selClient;
                curAudiencePath = ClientPath;
                curAudienceID = curSelectedClient.Id;
                saveSearchUrl += AgentPath;
                saveSearchUrl += authToken.Audience.Id + '/';
            }

            saveSearchUrl += curAudiencePath;
            saveSearchUrl += curAudienceID;

            if (self.state.saveSearchName && self.state.saveSearchName !== "") {
                let parameters = Object.assign({}, self.props.searchParameters_Redux);
                /* if (self.state.locationText && self.state.locationText !== "" &&
                (!parameters.MLSNumber || (parameters.MLSNumber && parameters.MLSNumber !== self.state.locationText))) {
                    if (IsMLSNumber(self.state.locationText)) {
                        parameters.MLSNumber = [];
                        parameters.MLSNumber.push(self.state.locationText.replace('#', ''));
                    }
                    else {
                        parameters.location = [];
                        parameters.location.push(self.state.locationText);
                    }

                    delete parameters["mapbound"];
                    delete parameters["addresses"];
                }

                if (parameters.polygon && parameters.polygon.length > 0) {
                    delete parameters["mapbound"];
                } */
                delete parameters["addresses"];

                //removing mapbound before saving search
                delete parameters["mapbound"];

                if (parameters.neighborhood && parameters.neighborhood.length > 0 && Array.isArray(parameters.neighborhood)) {
                    parameters.neighborhood = parameters.neighborhood.join(',');
                }
                else {
                    delete parameters["neighborhood"];
                }
                if (parameters.lotfeature && parameters.lotfeature.length > 0 && Array.isArray(parameters.lotfeature)) {
                    parameters.lotfeature = parameters.lotfeature.join(',');
                }
                else {
                    delete parameters["lotfeature"];
                }
                if (parameters.propertystyle && parameters.propertystyle.length > 0 && Array.isArray(parameters.propertystyle)) {
                    parameters.propertystyle = parameters.propertystyle.join(',');
                }
                else {
                    delete parameters["propertystyle"];
                }
                if (parameters.roompref && parameters.roompref.length > 0 && Array.isArray(parameters.roompref)) {
                    parameters.roompref = parameters.roompref.join(',');
                }
                else {
                    delete parameters["roompref"];
                }
                if (parameters.accessibility && parameters.accessibility.length > 0 && Array.isArray(parameters.accessibility)) {
                    parameters.accessibility = parameters.accessibility.join(',');
                }
                else {
                    delete parameters["accessibility"];
                }
                if (parameters.propertytype && parameters.propertytype.length > 0 && Array.isArray(parameters.propertytype)) {
                    parameters.propertytype = parameters.propertytype.join(',');
                }
                if (parameters.city && parameters.city.length > 0 && Array.isArray(parameters.city)) {
                    parameters.city = parameters.city.join(',');
                }
                if (parameters.postalcode && parameters.postalcode.length > 0 && Array.isArray(parameters.postalcode)) {
                    parameters.postalcode = parameters.postalcode.join(',');
                }

                if (!parameters.status || parameters.status === "") {
                    if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultStatuses && CommonCustomizationOptions.DefaultStatuses !== "") {
                        parameters.status = CommonCustomizationOptions.DefaultStatuses;
                    }
                }
                if ((parameters.streetaddress && parameters.streetaddress !== "")) {
                    if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultPropertyTypes && CommonCustomizationOptions.DefaultPropertyTypes !== "") {
                        parameters.propertytype = CommonCustomizationOptions.DefaultPropertyTypes;
                    }
                    if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultAutoSuggestStatuses && CommonCustomizationOptions.DefaultAutoSuggestStatuses !== "") {
                        parameters.status = CommonCustomizationOptions.DefaultAutoSuggestStatuses;
                    }
                }
                if (parameters.MLSNumber && !Array.isArray(parameters.MLSNumber)) {
                    parameters.MLSNumber = [parameters.MLSNumber];
                }
                if (parameters.MLSNumber && Array.isArray(parameters.MLSNumber) && parameters.MLSNumber.length > 0) {
                    if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultPropertyTypes && CommonCustomizationOptions.DefaultPropertyTypes !== "") {
                        parameters.propertytype = CommonCustomizationOptions.DefaultPropertyTypes;
                    }
                    if (CommonCustomizationOptions && CommonCustomizationOptions.DefaultAutoSuggestStatuses && CommonCustomizationOptions.DefaultAutoSuggestStatuses !== "") {
                        parameters.status = CommonCustomizationOptions.DefaultAutoSuggestStatuses;
                    }
                }
                if (parameters.location && Array.isArray(parameters.location) && parameters.location.length > 0) {
                    parameters.location = parameters.location.map(l => l = l.replace('-City', '').replace('-city', '').replace('-Town', '').replace('-town', ''));
                }
                else if (parameters.location && !Array.isArray(parameters.location)) {
                    parameters.location = [parameters.location];
                }
                if (parameters.exteriorhomestyle && parameters.exteriorhomestyle !== "") {
                    parameters.exteriorhomestyle = [parameters.exteriorhomestyle];
                }
                if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchListingsWithPhotosOnly){		
                    if(!parameters.MLSNumber && !parameters.streetaddress){		
                        parameters.listingwithphotoonly = 1;
                    }            		
                }		
                if(SiteCustomizationOptions && SiteCustomizationOptions.SearchListingsWithZeroOrMorePhotos){		
                    parameters.listingwithzeroorphoto = 1;		
                }

                var request = {
                    RequiredNotification: self.state.saveSearchNameRequiredNotification,
                    SearchName: self.state.saveSearchName,
                    SearchParameters: parameters
                };

                //If there is default agent then pass default agent id to use default agent specific email template
                if (process.env.REACT_APP_DefaultAgentId !== undefined &&
                    process.env.REACT_APP_DefaultAgentId !== null &&
                    process.env.REACT_APP_DefaultAgentId !== "") {
                    request.BrokerAgentId = process.env.REACT_APP_DefaultAgentId;
                }
                //---

                var url = window.sessionStorage.getItem("RootAPI") + saveSearchUrl + "/savedsearches";
                if (self.refs.searchBarRef) {
                    self.setState({ savingSearch: true });
                }
                fetch(url,
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
                        },
                        method: "POST",
                        body: JSON.stringify(request)
                    })
                    .then(response => response.json())
                    .then(json => {
                        var sMsg = "", eMsg = "";
                        var sName = self.state.saveSearchName;
                        if (json && json.Id && json.Id > 0 && json.Message) {
                            sMsg = "'" + request.SearchName + "' saved successfully";
                            sName = "";
                        }
                        else if (json && json.length > 0 && json[0].ErrorMessage) {
                            eMsg = json[0].ErrorMessage;
                            if (eMsg.toLowerCase().indexOf('already exist')) {
                                eMsg = "'" + request.SearchName + "' already exist. Please choose a different name.";
                            }
                        }
                        if (self.refs.searchBarRef) {
                            self.setState({ saveSearchName: sName, saveSearchSuccessMsg: sMsg, saveSearchErrorMsg: eMsg, savingSearch: false });
                        }
                    })
                    .catch(function (data) {
                        var eMsg = "Error while saving search";
                        if (data && data.length > 0 && data[0].ErrorMessage) {
                            eMsg = data[0].ErrorMessage;
                        }
                        if (self.refs.searchBarRef) {
                            self.setState({ saveSearchSuccessMsg: "", saveSearchErrorMsg: eMsg, savingSearch: false });
                        }
                    });
            }
            else {
                if (this.refs.searchBarRef) {
                    this.setState({ saveSearchErrorMsg: "Please enter a name to save this search" });
                }
            }
        }
    }


    openSaveSearch() {
        if (this.refs.searchBarRef) {
            this.setState({
                saveSearchName: getTextForSearchParameters(Object.assign({}, this.props.searchParameters_Redux), false),
                saveSearchSuccessMsg: "", saveSearchErrorMsg: ""
            });
        }
    }

    saveSearchNameChange(event) {
        const target = event.target;
        const value = target.value;
        if (this.refs.searchBarRef) {
            this.setState({ saveSearchName: value, saveSearchSuccessMsg: "", saveSearchErrorMsg: "" });
        }
    }

    saveSearchNameNotificationChange(event) {
        const target = event.target;
        const value = target.checked;
        if (this.refs.searchBarRef) {
            this.setState({ saveSearchNameRequiredNotification: value });
        }
    }

    saveSearchKeyDown(event) {
        if (event && event.key === "Enter") {
            event.preventDefault();
            this.onSaveSearch();
        }
    }

    setRecentSearch = (locationText) => {
        const cookies = new Cookies();
        var objRecentSearches = {};
        var recentSearchesCookie = cookies.get('recentSearches');
        if (recentSearchesCookie)
            objRecentSearches = recentSearchesCookie;

        var key = this.props.selectedClient ? this.props.selectedClient.Id : ((this.props.profile && this.props.profile.Email) ? this.props.profile.Email : "Anonymous");
        var searches = objRecentSearches[key] ?
            (objRecentSearches[key].indexOf(locationText) === -1 ? objRecentSearches[key].concat([locationText]) : objRecentSearches[key])
            : [locationText]
        searches = searches.slice(Math.max(searches.length - 3, 0));
        objRecentSearches[key] = searches;

        this.setState({ recentSearches: searches });
        var ninetyDays = new Date();
        ninetyDays.setDate(new Date().getDate() + 90);
        cookies.set('recentSearches', JSON.stringify(objRecentSearches), { expires: ninetyDays, path: '/' });
    }

    getRecentSearches = () => {
        const { profile, selectedClient } = this.props;
        const cookies = new Cookies();
        var recentSearches = cookies.get('recentSearches');
        if (recentSearches && selectedClient && recentSearches[selectedClient.Id])
            this.setState({ recentSearches: recentSearches[selectedClient.Id] });
        else if (!selectedClient && recentSearches && profile && recentSearches[profile.Email])
            this.setState({ recentSearches: recentSearches[profile.Email] });
        else {
            this.setState({ recentSearches: [] });
            console.log('no recentSearches cookie found. selectedClient:' + selectedClient + ' , profile: ' + profile);
        }
    }

    onLocationTextChange(event) {
        if (this.refs.searchBarRef) {
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            //if (event === "" && parameters.locationtext !== undefined && parameters.locationtext !== null && parameters.locationtext !== "") {
            if (event === "" && (parameters.location || parameters.MLSNumber)) {
                //delete parameters["locationtext"];
                delete parameters["location"];
                delete parameters["MLSNumber"];
                parameters.page_number = 1;
                parameters.skip = 0;
                window.sessionStorage.setItem("ClearLocationText","true");
                this.props.searchActions.updateParameters(parameters);
            }
            this.setState({ locationText: event, showNearbySearch: false, isLocationSearch: (event === "") ? false : true });
        }
    }

    onFocus(event) {
        if (this.refs.searchBarRef) {
            document.getElementsByClassName('rbt-input-main')[0].select();
            //if (event.target.placeholder === 'City, Zip or MLS#')
            //    this.setState({ showNearbySearch: true })
        }
    }

    onLocationTextClear(event) {
        if (this.refs.searchBarRef) {
            /* let parameters = Object.assign({}, this.props.searchParameters_Redux);
            delete parameters["MLSNumber"];
            this.props.searchActions.updateParameters(parameters);  */           
            this.setState({ locationText: "", isLocationSearch: false });
        }
    }

    clearAutoComplete = () => {
        if (this.esriAutoComplete && this.esriAutoComplete.getWrappedInstance() && this.esriAutoComplete.getWrappedInstance().clear) {
            this.esriAutoComplete.getWrappedInstance().clear();
        }
    }

    handleAutoComplete(obj) {
        window.sessionStorage.setItem("RemoveMapboundSearchParameter", true);
        
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (typeof obj === "string") { // clicking recent search item
            parameters.locationtext = obj;
            this.setState({ locationText: obj, recentSearchClicked: true, showNearbySearch: false });
        }
        else {
            this.setState({ recentSearchClicked: false });
            //parameters.locationtext = this.state.locationText;
            this.setRecentSearch(this.state.locationText);
        }
        delete parameters["mapbound"];
        if(obj && obj.SearchedText && obj.SearchedText !== "" && obj.SearchedParam && obj.SearchedParam !== ""){
            //if (parameters[obj.SearchedParam]) parameters[obj.SearchedParam] = parameters[obj.SearchedParam].concat([obj.SearchedText]);
            //else parameters[obj.SearchedParam] = [obj.SearchedText];
            parameters[obj.SearchedParam] = [obj.SearchedText];

            if(obj.SearchedParam !== "MLSNumber"){
                this.clearAutoComplete();
            }
            this.setState({ locationText: (obj.SearchedParam === "MLSNumber")  ? this.state.locationText : "", isLocationSearch: false });
        }

        this.props.searchActions.updateParameters(parameters);
    }

    autoCompleteEnterPressed = () => {
        var self = this;
        setTimeout(function() { 
            self.processAutoComplete();
        }, 500);
    }

    handleAutoCompleteBlur(e) {
        if (!this.state.askGeoLocation)
            this.setState({ showNearbySearch: false });
    }

    processAutoComplete = () => {
        var locText = this.state.locationText;
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        //var paramLoc = parameters.locationtext ? parameters.locationtext : "";
        //if (paramLoc !== locText && this.state.isLocationSearch) {
        if (locText && locText !== "" && this.state.isLocationSearch) {
            if(IsMultiZip(locText)){
                parameters.postalcode = locText.trim().replace(/(^,)|(,$)/g, "").replace(/ /g,"");
                this.clearAutoComplete();
                this.props.searchActions.updateParameters(parameters);
            }
            else if(IsSingleZip(locText)){
                parameters.postalcode = locText.trim();
                this.clearAutoComplete();
                this.props.searchActions.updateParameters(parameters);
            }
            else{                
                if (IsMLSNumber(locText) || locText !== "") {
                    if(IsMLSNumber(locText)){
                        parameters.MLSNumber = [];
                        parameters.MLSNumber.push(locText);
                        delete parameters["locationtext"];
                    }
                    else if (locText !== "") {
                        //parameters.locationtext = locText;
                        parameters.location = locText;
                    }
                    delete parameters["mapbound"];
                    this.props.searchActions.updateParameters(parameters);
                }
                /* if (locText === "") {
                    delete parameters["locationtext"];
                    console.log('after parameters');
                    console.log(JSON.stringify(parameters));
                    this.props.searchActions.updateParameters(parameters);
                } */
            }
        }
    }

    workingWithClient(selectedClient, profile) {
        //console.log('In SearchBar workingWithClient');
        const { audience } = this.props;

        if (audience && audience.type === 'client') {
            if (profile !== undefined && profile !== null) {
                this.setupTLCParams(profile);
            }
        }
        else {
            var sClient = selectedClient;
            if (sClient !== undefined && sClient !== null) {
                this.setupTLCParams(sClient);
            }
            else {
                this.setupTLCParams(null);
            }
        }
    }

    setupTLCParams(client) {
        //console.log('In SearchBar setupTLCParams');

        var sClient = Object.assign({}, client);

        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        let defaultParameters = getDefaultSearchParams();

        if (sClient && sClient.Profile && sClient.Profile.BasicData &&
            sClient.Profile.BasicData.CreditScore && sClient.Profile.BasicData.CreditScore !== "") {
            parameters.ficoscore = sClient.Profile.BasicData.CreditScore;
        }
        else {
            parameters.ficoscore = defaultParameters.ficoscore;
        }
        if (sClient && sClient.Profile && sClient.Profile.BasicData &&
            sClient.Profile.BasicData.LoanType && sClient.Profile.BasicData.LoanType !== "") {
            parameters.loantype = sClient.Profile.BasicData.LoanType;
        }
        else {
            parameters.loantype = defaultParameters.loantype;
        }
        if (sClient && sClient.Profile && sClient.Profile.BasicData &&
            sClient.Profile.BasicData.MStatus && sClient.Profile.BasicData.MStatus !== "") {
            parameters.lifestyle = sClient.Profile.BasicData.MStatus;
        }
        else {
            parameters.lifestyle = defaultParameters.lifestyle;
        }

        if (sClient && sClient.Profile && sClient.Profile.BasicData) {
            if (sClient.Profile.BasicData.TLCMin) {
                parameters.tlcmin = sClient.Profile.BasicData.TLCMin;
            }
            if (sClient.Profile.BasicData.TLCMax) {
                parameters.tlcmax = sClient.Profile.BasicData.TLCMax;
            }
        }

        var commuteLocation = null;
        var callSearch = true;

        //Based on client's requirement we don't consider client's commute any more
        /* if (sClient && sClient.Profile && sClient.Profile.CommuteData &&
            sClient.Profile.CommuteData.CommuteDetail && sClient.Profile.CommuteData.CommuteDetail.length > 0 &&
            sClient.Profile.CommuteData.CommuteDetail[0].WorkAddress &&
            sClient.Profile.CommuteData.CommuteDetail[0].WorkAddress !== "") {
            if (sClient.Profile.CommuteData.CommuteDetail[0].WorkAddress &&
                sClient.Profile.CommuteData.CommuteDetail[0].WorkAddress !== "") {

                parameters.commuteaddress = sClient.Profile.CommuteData.CommuteDetail[0].WorkAddress;
                commuteLocation = sClient.Profile.CommuteData.CommuteDetail[0].WorkAddress;
                parameters.commutetimemins = "45";
                delete parameters["mapbound"];
            }
            else {
                delete parameters["cpolygon"];
                delete parameters["commuteaddress"];
                delete parameters["commutetimemins"];
            }
        }
        else {
            delete parameters["cpolygon"];
            delete parameters["commuteaddress"];
            delete parameters["commutetimemins"];
        } */

        if (callSearch) {
            if (this.refs.searchBarRef) {
                this.setState({ commuteLocation: commuteLocation, sClient: sClient },
                    function () {
                        if (JSON.stringify(this.props.searchParameters_Redux) !== JSON.stringify(parameters)) {
                            this.props.searchActions.updateParameters(parameters);
                        }
                        else {
                            this.doSearch();
                        }
                    }
                );
            }
        }
    }

    onMoreFilterClick() {
        let self = this;
        if (self.refs.searchBarRef) {
            self.setState({ moreFilterState: !self.state.moreFilterState });
        }
    }

    closePopup = () => {
        if (this.sbOverlayTriggerRef) {
            this.sbOverlayTriggerRef.hide();
        }
    }

    hangleSearchBoxDisplay = () => {
        let self = this;
        if (self.refs.searchBarRef) {
            self.setState({ mSearchExpanded: !self.state.mSearchExpanded });
        }
    }

    onCheckChange = (e) => {
        if (e) {
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            if (e.target.checked) {
                if(e.target.name === "regionalboardcode" || e.target.name === "regionalboardcode_s") {
                    if(parameters.regionalboardcode && parameters.regionalboardcode !== ""){
                        parameters.regionalboardcode = parameters.regionalboardcode + "," + (e.target.name === "regionalboardcode_s" ? "syracuse" : "rochester");
                    }
                    else{
                        parameters.regionalboardcode = (e.target.name === "regionalboardcode_s" ? "syracuse" : "rochester");
                    }
                    //parameters[e.target.name] = "rochester";
                    delete parameters["neighborhood"];
                    delete parameters["schooldistrictname"];
                    if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchNeighborhoodsList){
                        this.props.settingActions.fetchBaseData('neighborhoods', {regionalboardcode: parameters.regionalboardcode});
                    }
                }
                else {
                    parameters[e.target.name] = "true";
                }
            }
            else {                
                if(e.target.name === "regionalboardcode" || e.target.name === "regionalboardcode_s") {
                    parameters.regionalboardcode = parameters.regionalboardcode.replace((e.target.name === "regionalboardcode_s" ? "syracuse" : "rochester"),"").replace(",","");
                    if(parameters.regionalboardcode === ""){
                        delete parameters["regionalboardcode"];
                    }
                    delete parameters["neighborhood"];
                    delete parameters["schooldistrictname"];
                    if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchNeighborhoodsList){
                        this.props.settingActions.fetchBaseData('neighborhoods', (!parameters.regionalboardcode ? {} : {regionalboardcode: parameters.regionalboardcode}));
                    }
                }
                else if(e.target.name === "searchmap"){		
                    delete parameters[e.target.name];
                    delete parameters["mapbound"];		
                }
                else{
                    delete parameters[e.target.name];
                }
            }
            parameters.page_number = 1;
            parameters.skip = 0;

            if (this.refs.searchBarRef) {
                this.props.searchActions.updateParameters(parameters);
            }
        }
    }

    onJointCheckChange = (e) => {
        if (e) {
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.page_number = 1;
            parameters.skip = 0;
            if (e.target.name.indexOf("_chkyes") > -1) {
                if (e.target.checked) {
                    parameters[e.target.name.replace("_chkyes", "")] = "true";
                }
                else {
                    delete parameters[e.target.name.replace("_chkyes", "")];
                }

                if (this.refs.searchBarRef) {
                    this.props.searchActions.updateParameters(parameters);
                }
            }
            else if (e.target.name.indexOf("_chkno") > -1) {
                if (e.target.checked) {
                    parameters[e.target.name.replace("_chkno", "")] = "false";
                }
                else {
                    delete parameters[e.target.name.replace("_chkno", "")];
                }

                if (this.refs.searchBarRef) {
                    this.props.searchActions.updateParameters(parameters);
                }
            }
        }
    }

    handleSelectValueChange = (ele, val) => {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = 1;
        parameters.skip = 0;

        if (val && val !== "" && val.length > 0) {
            parameters[ele] = val;
            if (ele === "neighborhood") {
                delete parameters["schooldistrictname"];
                if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchSchoolDistrictsList){
                    this.props.settingActions.fetchBaseData('schooldistrictnames', { neighborhood: Array.isArray(val) ? val.join(',') : val });
                }
            }
        }
        else {
            delete parameters[ele];
            if (ele === "neighborhood") {
                delete parameters["schooldistrictname"];
                if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.FetchSchoolDistrictsList){
                    this.props.settingActions.fetchBaseData('schooldistrictnames', {});
                }
            }
        }

        if (this.refs.searchBarRef) {
            this.props.searchActions.updateParameters(parameters);
        }
    }

    handleTextKeyDown = (event) => {
        if (event && event.target && (event.key === "Enter" || event.key === "Tab")) {
            event.preventDefault();
            this.updateValue(event);
        }
    }

    handleTextBlur = (event) => {
        this.updateValue(event);
    }

    updateValue = (event) => {
        if (event && event.target) {
            event.preventDefault();

            const ele = event.target.name;
            const value = event.target.value;
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.page_number = 1;
            parameters.skip = 0;
            if (value && value !== "") {
                parameters[ele] = value;
            }
            else {
                delete parameters[ele];
            }

            if (this.refs.searchBarRef) {
                this.props.searchActions.updateParameters(parameters);
            }
        }
    }

    changeSearchBy = (e) => {
        /* if(e && e !== ""){
            if(this.esriAutoComplete && this.esriAutoComplete.getWrappedInstance()){
                var phold = (e === "place") ? "City, Zip or #MLS" : "Search MLS";
                this.esriAutoComplete.getWrappedInstance().props.placeholder = phold;
                this.setState({searchByParam: e});
            }
        } */
    }

    getSchoolDistrictNames = () => {
        const { schooldistrictnames } = this.props;
        var lst = [];
        /* lst.push(<option key="sdn_0" value="">School District</option>);
        schooldistrictnames.map((item,i) => {
            lst.push(<option key={"sdn_" + (i+1)} value={item}>{item}</option>);
            return null;
        }); */
        lst.push({ value: "", text: "School District" });
        schooldistrictnames.map((item, i) => {
            lst.push({ value: item, text: item });
            return null;
        });
        return lst;
    }

    getNeighborhoodNames = () => {
        const { neighborhoods } = this.props;
        var lst = [];
        /* //lst.push(<option key="nhn_0_0" value="">Neighborhood</option>);
        neighborhoods.map((item,i) => {
            if(item && item.CountyName && item.CountyName !== ""){
                lst.push(<option key={"nhn_" + (i+1) + "_0"} value={item.CountyName} className="font-bold">{getNeighborhoodItemText(item.CountyName) + " County"}</option>);
            }

            if(item && item.CityVillage && item.CityVillage.length > 0){
                item.CityVillage.map((nitem,j) => {
                    lst.push(<option key={"nhn_" + (i+1) + "_" + (j+1)} value={nitem}>{getNeighborhoodItemText(nitem)}</option>);
                    return null;
                });
            }

            return null;
        }); */
        neighborhoods.map((item, i) => {
            if (item && item.CountyName && item.CountyName !== "") {
                lst.push({ value: item.CountyName, text: getNeighborhoodItemText(item.CountyName) + " County" });
            }

            if (item && item.CityVillage && item.CityVillage.length > 0) {
                item.CityVillage.map((nitem, j) => {
                    lst.push({ value: nitem, text: getNeighborhoodItemText(nitem) });
                    return null;
                });
            }

            return null;
        });
        return lst;
    }

    getControl = (sElement) => {
        if(sElement){
            if(sElement.Name === "entrydayold"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getEntryDays()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getEntryDays()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "regionalboardcode"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name].indexOf("rochester") >= 0) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name].indexOf("rochester") >= 0) ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "isnewconstruction"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "isforeclosure"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "isfarmland"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "openHouseOnly"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={"id_" + sElement.Name} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>                        
                    </div>
                );
            }
            else if(sElement.Name === "propertytype"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <SelectBox
                            label={sElement.Placeholder}
                            multiple="true"
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "dropdown tru-dropdown square selected" : "dropdown tru-dropdown square"}
                            value={this.props.searchParameters_Redux[sElement.Name]}
                            onChange={this.handlePropertyTypeChange}>
                            {getFormattedOptions(getPropertyTypes())}
                        </SelectBox>                  
                    </div>
                );
            }
            else if(sElement.Name === "stories"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getStories()), this.props.searchParameters_Redux.stories, false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getStories()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "lotfeature"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            isMulti={true}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "" && this.props.searchParameters_Redux[sElement.Name].length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect(getLotFeatures(), this.props.searchParameters_Redux[sElement.Name], true)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect(getLotFeatures())}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "haswaterfront"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "haswaterview"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "neighborhood"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            isMulti={true}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "" && this.props.searchParameters_Redux[sElement.Name].length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            styles={{
                                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                    const fBold = (data.label.indexOf(' County') >= 0) ? "bold" : "inherit";
                                    return {
                                    ...styles,
                                    fontWeight: isDisabled
                                        ? null
                                        : fBold,                                                  
                                    };
                                }
                            }}
                            value={getFormattedValueForReactSelect(this.getNeighborhoodNames(), this.props.searchParameters_Redux[sElement.Name], true)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect(this.getNeighborhoodNames())}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "propertystyle"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            isMulti={true}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "" && this.props.searchParameters_Redux[sElement.Name].length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect(getPropertyStyles(), this.props.searchParameters_Redux[sElement.Name], true)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect(getPropertyStyles())}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "acresmin"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getLotSizes()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getLotSizes()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "hasbasement"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasfireplace"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "schooldistrictname"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect(this.getSchoolDistrictNames(), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect(this.getSchoolDistrictNames())}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "roompref"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            isMulti={true}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "" && this.props.searchParameters_Redux[sElement.Name].length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect(getRooms(), this.props.searchParameters_Redux[sElement.Name], true)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect(getRooms())}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "accessibility"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            isMulti={true}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "" && this.props.searchParameters_Redux[sElement.Name].length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect(getAccessibilities(), this.props.searchParameters_Redux[sElement.Name], true)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect(getAccessibilities())}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "isshortsale"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_true"} type="checkbox" name={sElement.Name + "_chkyes"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check"><span></span></span>
                            </label>
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_false"} type="checkbox" name={sElement.Name + "_chkno"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "postalcode"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div>
                            <input type="text"
                                ref={(ref) => this.postalCodeRef = ref}
                                name={sElement.Name}
                                placeholder={sElement.Placeholder}
                                className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "form-control textbox textbox-large selected" : "form-control textbox textbox-large"}
                                defaultValue={(this.props.searchParameters_Redux[sElement.Name]) ? this.props.searchParameters_Redux[sElement.Name] : ""}
                                onKeyDown={this.handleTextKeyDown}
                                onBlur={this.handleTextBlur} />
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "yearbuiltmin"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getBuiltYears()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getBuiltYears()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "garages"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getGarages()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getGarages()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "haspool"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_true"} type="checkbox" name={sElement.Name + "_chkyes"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check"><span></span></span>
                            </label>
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_false"} type="checkbox" name={sElement.Name + "_chkno"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hoafeemax"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getMaxHOAFees()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getMaxHOAFees()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "livingareamin"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getHomeSizes()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getHomeSizes()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "condotype"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getCondoTypes()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getCondoTypes()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "commute"){

                var addCommutePopover = (
                    <Popover id="popover-save-search" className="commute_filter" style={{ zIndex: "99999", maxWidth: "300px", padding: "0px" }}>
                        <CommutePopup closePopup={this.closePopup} />
                    </Popover>
                );

                return (            
                    <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={addCommutePopover} key={"tlc-" + sElement.Name + "-filter"} ref={(ref) => this.sbOverlayTriggerRef = ref}>
                        <div className={sElement.Class}>
                            <div className={(this.props.searchParameters_Redux.commuteaddress && this.props.searchParameters_Redux.commuteaddress !== "") ? "tru-dropdown square filter_inner_commute selected" : "tru-dropdown square filter_inner_commute"}>
                                {(this.props.searchParameters_Redux &&
                                    this.props.searchParameters_Redux.commutetimemins && this.props.searchParameters_Redux.commutetimemins !== "" &&
                                    this.props.searchParameters_Redux.commuteaddress && this.props.searchParameters_Redux.commuteaddress !== "") ?
                                    <div className="commute_car"><i className="fa fa-car orange"></i></div> :
                                    <div className="commute_car"><i className="fa fa-car"></i></div>
                                }
                                {(this.props.searchParameters_Redux &&
                                    this.props.searchParameters_Redux.commutetimemins && this.props.searchParameters_Redux.commutetimemins !== "" &&
                                    this.props.searchParameters_Redux.commuteaddress && this.props.searchParameters_Redux.commuteaddress !== "") ?
                                    <div className="location_name"><span>{this.props.searchParameters_Redux.commutetimemins} mins</span> from {this.props.searchParameters_Redux.commuteaddress}</div> :
                                    <div className="location_name">{sElement.Placeholder}</div>
                                }
                            </div>
                        </div>
                    </OverlayTrigger>                    
                );
            }
            else if(sElement.Name === "status"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <SelectBox
                            label={sElement.Placeholder}
                            className="dropdown tru-dropdown square selected"
                            value={(this.props.searchParameters_Redux[sElement.Name]) ? this.props.searchParameters_Redux[sElement.Name] : "Active"}
                            onChange={(v) => this.handleSelectValueChange(sElement.Name, v)}>
                            {getFormattedOptions(getSearchStatuses())}
                        </SelectBox>
                    </div>
                );
            }
            else if(sElement.Name === "waterfeatures"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        {/* <SelectBox
                            label={sElement.Placeholder}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "dropdown tru-dropdown square selected" : "dropdown tru-dropdown square"}
                            value={(this.props.searchParameters_Redux[sElement.Name]) ? this.props.searchParameters_Redux[sElement.Name] : ""}
                            onChange={(v) => this.handleSelectValueChange(sElement.Name, v)}>
                            {getFormattedOptions([{ value: "", text: sElement.Placeholder }].concat(getWaterFrontTypes()))}
                        </SelectBox> */}
                        <Select
                            placeholder={sElement.Placeholder}
                            name={sElement.Name}
                            className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                            classNamePrefix="react-select"
                            value={getFormattedValueForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getWaterFrontTypes()), this.props.searchParameters_Redux[sElement.Name], false)}
                            onChange={(e) => this.handleReactSelectChange(e, sElement.Name)}
                            options={getFormattedOptionsForReactSelect([{ value: "", text: sElement.Placeholder }].concat(getWaterFrontTypes()))}
                        />
                    </div>
                );
            }
            else if(sElement.Name === "isbankowned"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_true"} type="checkbox" name={sElement.Name + "_chkyes"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check"><span></span></span>
                            </label>
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_false"} type="checkbox" name={sElement.Name + "_chkno"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "haswateraccess"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_true"} type="checkbox" name={sElement.Name + "_chkyes"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check"><span></span></span>
                            </label>
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_false"} type="checkbox" name={sElement.Name + "_chkno"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasgolfcourse"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_true"} type="checkbox" name={sElement.Name + "_chkyes"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check"><span></span></span>
                            </label>
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_false"} type="checkbox" name={sElement.Name + "_chkno"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasgreenfeatures"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_true"} type="checkbox" name={sElement.Name + "_chkyes"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check"><span></span></span>
                            </label>
                            <label className="tru-checkbox-gray joint-checkbox">
                                <input id={sElement.Name + "_false"} type="checkbox" name={sElement.Name + "_chkno"} onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "false") ? "checked" : ""} />
                                <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "dpr"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "keywords"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div>
                            <input type="text"
                                ref={(ref) => this.keywordsRef = ref}
                                name={sElement.Name}
                                placeholder={sElement.Placeholder}
                                className={(this.props.searchParameters_Redux[sElement.Name] && this.props.searchParameters_Redux[sElement.Name] !== "") ? "form-control textbox textbox-large selected" : "form-control textbox textbox-large"}
                                defaultValue={(this.props.searchParameters_Redux[sElement.Name]) ? this.props.searchParameters_Redux[sElement.Name] : ""}
                                onKeyDown={this.handleTextKeyDown}
                                onBlur={this.handleTextBlur} />
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasgym"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasairconditioning"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasdoorman"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasdishwasher"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasbalcony"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "hasroofaccess"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
            else if(sElement.Name === "haskeylessentry"){
                return (
                    <div className={sElement.Class} key={"tlc-" + sElement.Name + "-filter"}>
                        <div className="tru-checkbox-area mg-top-12">
                            <label className="tru-checkbox">
                                <input id={sElement.Name + "_check"} type="checkbox" name={sElement.Name} onChange={this.onCheckChange} value={(this.props.searchParameters_Redux[sElement.Name]) ? "true" : "false"} checked={(this.props.searchParameters_Redux[sElement.Name] === "true") ? "checked" : ""} />
                                <span className="tru-checkbox_checkmark"></span>
                            </label>
                            <div className="tru-checkbok-name">{sElement.Placeholder}</div>
                        </div>
                    </div>
                );
            }
        }

        return null;
    }

    render() {

        let searchBtn = (this.state.fetchingResult) ?
            (<span id="search_filter_icon" className="searchfilter-bar-btn js-close-input-search" style={{ cursor: "pointer" }} key="searchbtn">
                {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchButtonProcessingTextOnMainSearchBar === "icon") ? (<Loader inline="true" width="18" height="18" />) :
                ((SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchButtonProcessingTextOnMainSearchBar && SearchPageCustomizationOptions.SearchButtonProcessingTextOnMainSearchBar !== "") ? SearchPageCustomizationOptions.SearchButtonProcessingTextOnMainSearchBar : "Updating your search")}
            </span>) :
            (<span id="search_filter_icon" className="searchfilter-bar-btn js-close-input-search" onClick={() => { this.setState({ moreFilterState: false }); this.onSearch(); }} style={{ cursor: "pointer" }} key="searchbtn">
                {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchButtonTextOnMainSearchBar === "icon") ? (<i className="fa fa-search"></i>) :
                ((SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchButtonTextOnMainSearchBar && SearchPageCustomizationOptions.SearchButtonTextOnMainSearchBar !== "") ? SearchPageCustomizationOptions.SearchButtonTextOnMainSearchBar : "Find your home")}
            </span>);
        
        if (window.innerWidth >= 768 && window.innerWidth <= 1159) {
            searchBtn = (this.state.fetchingResult) ?
                (<span className="searchfilter-bar-btn js-close-input-search" style={{ paddingTop: "10px" }} key="searchbtn">
                    <Loader inline="true" width="18" height="18" />
                </span>) :
                (<span id="search_filter_icon" className="searchfilter-bar-btn js-close-input-search" onClick={this.onSearch} style={{ cursor: "pointer" }} key="searchbtn">
                    <i className="fa fa-search"></i>
                </span>);
        }

        var tlcTooltipText = "<span>" +
            "TLC is the monthly budget range that takes into account your mortgage, taxes and insurance, but also costs such as entertainment, utilities, homeowners insurance, gas pricing, commuting, and other factors contributing to your total cost of home ownership.</br></br>"
            + "If you’re curious, each property page breaks down the cost of each expense as it’s predicted for that property."
            + "</span>";
        var tlcInfoText = (
            <span className="fico_tlctext">
                True Lifestyle Cost (TLC) is based on {(this.props.searchParameters_Redux && this.props.searchParameters_Redux.ficoscore) ? this.props.searchParameters_Redux.ficoscore + " FICO" : ""}
                {(this.props.searchParameters_Redux && this.props.searchParameters_Redux.loantype) ? ", " + getLoanTypeName(this.props.searchParameters_Redux.loantype) : ""}
                {(this.props.searchParameters_Redux && this.props.searchParameters_Redux.lifestyle) ? ", " + getFamilyTypeName(this.props.searchParameters_Redux.lifestyle) : ""}
                {(window.sessionStorage.getItem("APIAudience") === 'agents/' && this.props.selectedClient ? "" : 
                    (window.sessionStorage.getItem("APIAudience") === 'agents/' ? ", 20% Downpayment (editable in property details page)" : ""))}
                {(window.sessionStorage.getItem("APIAudience") === 'agents/' && this.props.selectedClient && this.props.selectedClient.FirstName ? " from " + this.props.selectedClient.FirstName + "'s profile. " :
                    (window.sessionStorage.getItem("APIAudience") !== 'agents/' ? " from your profile. " : "."))}
                {(window.sessionStorage.getItem("APIAudience") === 'agents/' && this.props.selectedClient && this.props.selectedClient.FirstName) &&
                    <Link to={'/agent/clients/' + this.props.selectedClient.Id} alt='' className="anchor-link">[Change]</Link>
                }
                {window.sessionStorage.getItem("APIAudience") !== 'agents/' &&
                    <Link to={'/profile'} alt='' className="anchor-link">[Change]</Link>
                }
            </span>
        );

        var saveSearchPopover = null;
        //var saveSearch = null;
        var saveSearchMoreBtn = null;
        var saveSearchSuccessMsg = null;
        var viewSavedSearchBtn = null;
        var saveSearchErrorMsg = null;
        var saveSearchButton = null;
        //var saveSearchOverlayBtn = null;
        if (!this.state.fetchingResult) {

            if (this.state.saveSearchSuccessMsg) {
                saveSearchSuccessMsg = (
                    <Alert bsStyle="success">
                        {this.state.saveSearchSuccessMsg}
                    </Alert>);
                if (this.props.selectedClient && this.props.selectedClient.Id) {
                    viewSavedSearchBtn = (
                        <div style={{ textAlign: 'center' }}>
                            <Link to={'/agent/clients/' + this.props.selectedClient.Id} style={{ textDecoration: "none" }} className='btn btn-default btn-xs' onClick={this.props.closeSelectClientPopup}>
                                View Saved Searches of {this.props.selectedClient.FirstName + " " + this.props.selectedClient.LastName}
                            </Link>
                        </div>
                    );
                }
                else {
                    viewSavedSearchBtn = (
                        <div style={{ textAlign: 'center' }}>
                            <Link to='/dashboard/savedsearches' style={{ textDecoration: "none" }} className='btn btn-default btn-xs' onClick={this.props.closeSelectClientPopup}>
                                View My Saved Searches
                                </Link>
                        </div>
                    );

                }
            }
            if (this.state.saveSearchErrorMsg) {
                saveSearchErrorMsg = (
                    <Alert bsStyle="danger">
                        {this.state.saveSearchErrorMsg}
                    </Alert>);
            }

            if (this.state.savingSearch) {
                saveSearchButton = (
                    <span className="input-group-addon js-close-input-search" style={{ paddingLeft: "10px" }}>
                        <Loader inline="true" width="18" height="18" />
                    </span>
                );
            }
            else {
                saveSearchButton = (
                    <span className="input-group-addon js-close-input-search" onClick={this.onSaveSearch}
                        style={{ cursor: "pointer", paddingLeft: "10px" }}>
                        <i id="savesearch_btn" className="fa plus"></i> Save
                    </span>
                );
            }

            saveSearchPopover = (
                <Popover id="popover-save-search" className="save_search_pop add_alert_scroll" style={{ zIndex: "9999", maxWidth: "450px" }}>
                    <div className="form-group dailyalert_poup">
                        Receive daily email updates based on saved search criteria.
                        {window.sessionStorage.getItem("APIAudience") === 'agents/' && !this.props.selectedClient &&
                            <div className='margintop10'>You can assign a search to a Client by selecting a Client from the top menu.</div>
                        }
                        {window.sessionStorage.getItem("APIAudience") === 'agents/' && this.props.selectedClient &&
                            <div className='margintop10'>Search will be saved for <strong>{this.props.selectedClient.FirstName + " " + this.props.selectedClient.LastName}</strong>.</div>
                        }
                        <div className="alerts_save">
                            <i className="fa fa-bell"></i>Receive daily alerts
                            <div className="alerts_input">
                                <input type="checkbox" value="on" checked={this.state.saveSearchNameRequiredNotification} onChange={this.saveSearchNameNotificationChange} />
                            </div>
                        </div>

                        <div className="input-group margintop10" style={{ border: "1px solid #ddd" }}>
                            <input type="text"
                                className="form-control"
                                placeholder="Search Description"
                                value={this.state.saveSearchName}
                                onChange={this.saveSearchNameChange}
                                onKeyDown={this.saveSearchKeyDown} />
                            {saveSearchButton}
                        </div>
                    </div>
                    {saveSearchSuccessMsg}
                    {viewSavedSearchBtn}
                    {saveSearchErrorMsg}
                </Popover>
            );

            saveSearchMoreBtn = (
                <OverlayTrigger trigger="click" placement="top" rootClose overlay={saveSearchPopover} key="otMbtnSaveSearch">
                    <button id="save_search" className="tru-btn tru-btn-big tru-btn-default resize_btn mg-rt-20 mb-mg-rt-5" onClick={this.openSaveSearch}>                        
                        {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SaveSearchButtonTextInAdvanced && SearchPageCustomizationOptions.SaveSearchButtonTextInAdvanced !== "") ? SearchPageCustomizationOptions.SaveSearchButtonTextInAdvanced : "Save Search"}
                    </button>
                </OverlayTrigger>
            );

            var ResetBtn = null;
            if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowResetButtonOnMainSearchBar) {
                
                ResetBtn = (
                    <button key="resetbtn" className="searchfilter-bar-btn resetfilter-bar-btn" onClick={this.resetSearch}>
                        {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ResetButtonTextOnMainSearchBar === "icon") ? (<i className="fa fa-refresh"></i>) :
                        ((SearchPageCustomizationOptions && SearchPageCustomizationOptions.ResetButtonTextOnMainSearchBar && SearchPageCustomizationOptions.ResetButtonTextOnMainSearchBar !== "") ? SearchPageCustomizationOptions.ResetButtonTextOnMainSearchBar : "Reset")}
                    </button>
                );

                if (window.innerWidth >= 768 && window.innerWidth <= 1159) {
                    ResetBtn = (this.state.fetchingResult) ?
                        (<span className="searchfilter-bar-btn js-close-input-search" style={{ paddingTop: "10px" }} key="resetbtn">
                            <Loader inline="true" width="18" height="18" />
                        </span>) :
                        (<span className="searchfilter-bar-btn" onClick={this.resetSearch} style={{ cursor: "pointer" }} key="resetbtn">
                            <i className="fa fa-refresh"></i>
                        </span>)
                }
            }

            var saveSearchMainBtn = null;
            if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowSaveSearchButtonOnMainSearchBar){
                
                saveSearchMainBtn = (
                    <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={saveSearchPopover} key="mainBtnSaveSearch">
                        <button id="save_search_main" className="searchfilter-bar-btn savefilter-bar-btn" onClick={this.openSaveSearch}>                            
                            {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SaveSearchButtonTextOnMainSearchBar === "icon") ? (<i className="fa fa-floppy-o"></i>) :
                            ((SearchPageCustomizationOptions && SearchPageCustomizationOptions.SaveSearchButtonTextOnMainSearchBar && SearchPageCustomizationOptions.SaveSearchButtonTextOnMainSearchBar !== "") ? SearchPageCustomizationOptions.SaveSearchButtonTextOnMainSearchBar : "Save search")}
                        </button>
                    </OverlayTrigger>
                );

                if (window.innerWidth >= 768 && window.innerWidth <= 1159) {
                    saveSearchMainBtn = (this.state.fetchingResult) ?
                        (<span className="searchfilter-bar-btn js-close-input-search" style={{ paddingTop: "16px" }} key="mainBtnSaveSearch">
                            <Loader inline="true" width="18" height="18" />
                        </span>) :
                        (<OverlayTrigger trigger="click" placement="bottom" rootClose overlay={saveSearchPopover} key="mainBtnSaveSearch">
                            <button id="save_search_main" className="searchfilter-bar-btn" onClick={this.openSaveSearch}><i className="fa fa-floppy-o"></i></button>
                        </OverlayTrigger>);
                }
            }
        }

        var moreFilterClass = "filter_view_pop hide_filter";
        if (this.state && this.state.moreFilterState && this.state.moreFilterState === true) {
            moreFilterClass = "filter_view_pop show_filter";
        }

        var tlcMinMaxFilter = {};
        if (window.innerWidth > 767) {
            var tlcMinMaxFilterClass = "filter_tlc_pr";
            if (this.props.searchParameters_Redux.tlcmin || this.props.searchParameters_Redux.tlcmax ||
                this.props.searchParameters_Redux.listingpricemin || this.props.searchParameters_Redux.listingpricemax) {
                tlcMinMaxFilterClass = "filter_tlc_pr selected";
            }
            tlcMinMaxFilter = (
                <li className="ribbon select_style lifestyle-item-cost pd-top-15 pd-bot-15 border-left-gray" key="tlcMinMax">
                    <div className={tlcMinMaxFilterClass}>
                        <SmartRange
                            cssClass="smart-tlc-range"
                            placeholder={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.TlcPriceSCPlaceholder) ? SearchPageCustomizationOptions.TlcPriceSCPlaceholder : "True Lifestyle Cost/Price"}
                            minPlaceholder="Min TLC"
                            maxPlaceholder="Max TLC"
                            minValues={getMinTLCRange()}
                            maxValues={getMaxTLCRange()}
                            minHintText="TLC: $"
                            maxHintText="$"
                            noMinHintText="TLC: No Min"
                            tooltipText={tlcTooltipText}
                            infoText={tlcInfoText}
                            minimumItemValue={(this.props.searchParameters_Redux.tlcmin) ? this.props.searchParameters_Redux.tlcmin : ""}
                            maximumItemValue={(this.props.searchParameters_Redux.tlcmax) ? this.props.searchParameters_Redux.tlcmax : ""}
                            handleSmartRangeValueChange={this.handleTLCRangeValueChange}
                            multiTabs={true}
                            secondPlaceholder={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.TlcPriceSCPlaceholder) ? SearchPageCustomizationOptions.TlcPriceSCPlaceholder : "True Lifestyle Cost/Price"}
                            secondMinPlaceholder="Min price"
                            secondMaxPlaceholder="Max price"
                            secondMinValues={getMinPriceRange()}
                            secondMaxValues={getMaxPriceRange()}
                            secondMinHintText="List Price: $"
                            secondMaxHintText="$"
                            secondNoMinHintText="List Price: No Min"
                            secondMinimumItemValue={(this.props.searchParameters_Redux.listingpricemin) ? this.props.searchParameters_Redux.listingpricemin : ""}
                            secondMaximumItemValue={(this.props.searchParameters_Redux.listingpricemax) ? this.props.searchParameters_Redux.listingpricemax : ""}
                            handleSecondSmartRangeValueChange={this.handlePriceRangeValueChange}
                            activeTabKey={
                                (this.props.searchParameters_Redux.tlcmin || this.props.searchParameters_Redux.tlcmax) ? 1 :
                                    ((this.props.searchParameters_Redux.listingpricemin || this.props.searchParameters_Redux.listingpricemax) ? 2 : 
                                    ((SearchPageCustomizationOptions && SearchPageCustomizationOptions.TlcPriceSCActive === "price") ? 2 : 1))
                            }
                        />
                    </div>
                </li>
            );
        }
        else {
            tlcMinMaxFilterClass = "dropdown tru-dropdown square mbl";
            if (this.props.searchParameters_Redux.tlcmin || this.props.searchParameters_Redux.tlcmax ||
                this.props.searchParameters_Redux.listingpricemin || this.props.searchParameters_Redux.listingpricemax) {
                tlcMinMaxFilterClass = "dropdown tru-dropdown square mbl selected";
            }
            tlcMinMaxFilter = (
                <div className="ribbon col-md-3 col-sm-4 col-xs-12 form-group monthly_costbox" key="tlcMinMax">
                    <div className={tlcMinMaxFilterClass}>
                        <span>
                            <SmartRange
                                cssClass="smart-tlc-range mob"
                                placeholder={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.TlcPriceSCPlaceholderMobile) ? SearchPageCustomizationOptions.TlcPriceSCPlaceholderMobile : "True Lifestyle Cost/Price"}
                                minPlaceholder="Min TLC"
                                maxPlaceholder="Max TLC"
                                minValues={getMinTLCRange()}
                                maxValues={getMaxTLCRange()}
                                minHintText="TLC: $"
                                maxHintText="$"
                                noMinHintText="TLC: No Min"
                                tooltipText={tlcTooltipText}
                                infoText={tlcInfoText}
                                minimumItemValue={(this.props.searchParameters_Redux.tlcmin) ? this.props.searchParameters_Redux.tlcmin : ""}
                                maximumItemValue={(this.props.searchParameters_Redux.tlcmax) ? this.props.searchParameters_Redux.tlcmax : ""}
                                handleSmartRangeValueChange={this.handleTLCRangeValueChange}
                                multiTabs={true}
                                secondPlaceholder={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.TlcPriceSCPlaceholderMobile) ? SearchPageCustomizationOptions.TlcPriceSCPlaceholderMobile : "True Lifestyle Cost/Price"}
                                secondMinPlaceholder="Min price"
                                secondMaxPlaceholder="Max Price"
                                secondMinValues={getMinPriceRange()}
                                secondMaxValues={getMaxPriceRange()}
                                secondMinHintText="List Price: $"
                                secondMaxHintText="$"
                                secondNoMinHintText="List Price: No Min"
                                secondMinimumItemValue={(this.props.searchParameters_Redux.listingpricemin) ? this.props.searchParameters_Redux.listingpricemin : ""}
                                secondMaximumItemValue={(this.props.searchParameters_Redux.listingpricemax) ? this.props.searchParameters_Redux.listingpricemax : ""}
                                handleSecondSmartRangeValueChange={this.handlePriceRangeValueChange}
                                activeTabKey={
                                    (this.props.searchParameters_Redux.tlcmin || this.props.searchParameters_Redux.tlcmax) ? 1 :
                                        ((this.props.searchParameters_Redux.listingpricemin || this.props.searchParameters_Redux.listingpricemax) ? 2 : 
                                        ((SearchPageCustomizationOptions && SearchPageCustomizationOptions.TlcPriceSCActive === "price") ? 2 : 1))
                                }
                            />
                            <i className="fa fa-question-circle" data-html={true} data-class="tooltip_box" data-tip={tlcTooltipText}></i>
                        </span>
                    </div>
                </div>
            );
        }

        var tlcBedFilter = {};
        var tlcBedFilterClass = "";
        if (window.innerWidth > 767) {
            tlcBedFilterClass = "dropdown semicompact search_semicompact";
            if (this.props.searchParameters_Redux.beds) {
                tlcBedFilterClass = "dropdown semicompact search_semicompact selected";
            }
            tlcBedFilter = (<li className="ribbon select_style beds-item-filter pd-top-15 pd-bot-15 border-left-gray" key="tlcBed">
                <SelectBox
                    label="Beds"
                    className={tlcBedFilterClass}
                    value={(this.props.searchParameters_Redux.beds) ? this.props.searchParameters_Redux.beds : ""}
                    onChange={this.handleBedsChange}>
                    {getFormattedOptions([{ value: "", text: "Beds" }].concat(getBeds()))}
                </SelectBox>
            </li>);
        }
        else {
            tlcBedFilterClass = "dropdown tru-dropdown square";
            if (this.props.searchParameters_Redux.beds) {
                tlcBedFilterClass = "dropdown tru-dropdown square selected";
            }
            tlcBedFilter = (
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBed">
                    <SelectBox
                        label="Beds"
                        className={tlcBedFilterClass}
                        value={(this.props.searchParameters_Redux.beds) ? this.props.searchParameters_Redux.beds : ""}
                        onChange={this.handleBedsChange}>
                        {getFormattedOptions([{ value: "", text: "Beds" }].concat(getBeds()))}
                    </SelectBox>
                </div>);
        }
        var tlcBathFilter = {};
        var tlcBathFilterClass = "";
        if (window.innerWidth > 767) {
            tlcBathFilterClass = "dropdown semicompact search_semicompact";
            if (this.props.searchParameters_Redux.baths) {
                tlcBathFilterClass = "dropdown semicompact search_semicompact selected";
            }
            tlcBathFilter = (<li className="ribbon select_style baths-item-filter pd-top-15 pd-bot-15 border-left-gray" key="tlcBath">
                <SelectBox
                    label="Baths"
                    className={tlcBathFilterClass}
                    value={(this.props.searchParameters_Redux.baths) ? this.props.searchParameters_Redux.baths : ""}
                    onChange={this.handleBathChange}>
                    {getFormattedOptions([{ value: "", text: "Baths" }].concat(getBaths()))}
                </SelectBox>
            </li>);
        }
        else {
            tlcBathFilterClass = "dropdown tru-dropdown square";
            if (this.props.searchParameters_Redux.baths) {
                tlcBathFilterClass = "dropdown tru-dropdown square selected";
            }
            tlcBathFilter = (
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBath">
                    <SelectBox
                        label="Baths"
                        className={tlcBathFilterClass}
                        value={(this.props.searchParameters_Redux.baths) ? this.props.searchParameters_Redux.baths : ""}
                        onChange={this.handleBathChange}>
                        {getFormattedOptions([{ value: "", text: "Baths" }].concat(getBaths()))}
                    </SelectBox>
                </div>);
        }

        /* var addCommutePopover = (
            <Popover id="popover-save-search" className="commute_filter" style={{ zIndex: "99999", maxWidth: "300px", padding: "0px" }}>
                <CommutePopup closePopup={this.closePopup} />
            </Popover>
        ); */

        /* var includeCommuteControl = (
            <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={addCommutePopover} key="otCommute" ref={(ref) => this.sbOverlayTriggerRef = ref}>
                <div className="col-md-3 col-sm-4 col-xs-12 form-group">
                    <div className={(this.props.searchParameters_Redux.commuteaddress && this.props.searchParameters_Redux.commuteaddress !== "") ? "tru-dropdown square filter_inner_commute selected" : "tru-dropdown square filter_inner_commute"}>
                        {(this.props.searchParameters_Redux &&
                            this.props.searchParameters_Redux.commutetimemins && this.props.searchParameters_Redux.commutetimemins !== "" &&
                            this.props.searchParameters_Redux.commuteaddress && this.props.searchParameters_Redux.commuteaddress !== "") ?
                            <div className="commute_car"><i className="fa fa-car orange"></i></div> :
                            <div className="commute_car"><i className="fa fa-car"></i></div>
                        }
                        {(this.props.searchParameters_Redux &&
                            this.props.searchParameters_Redux.commutetimemins && this.props.searchParameters_Redux.commutetimemins !== "" &&
                            this.props.searchParameters_Redux.commuteaddress && this.props.searchParameters_Redux.commuteaddress !== "") ?
                            <div className="location_name"><span>{this.props.searchParameters_Redux.commutetimemins} mins</span> from {this.props.searchParameters_Redux.commuteaddress}</div> :
                            <div className="location_name">Filter by commute time</div>
                        }
                    </div>
                </div>
            </OverlayTrigger>
        ); */

        var tlcMoreFilter = (<li className="ribbon select_style mob_select_style more-item-filter border-left-gray" key="tlcMrFlt">
            <div className="filter_more" onClick={this.onMoreFilterClick}>
                <span>{this.state.moreFilterState ? "Advanced" : "Advanced"}</span> <i className={this.state.moreFilterState ? "fa fa-angle-up" : "fa fa-angle-down"}></i>
            </div>
        </li>);

        if (window.innerWidth < 768) {
            tlcMoreFilter = (<li className={this.state.moreFilterState ? "ribbon select_style mob_select_style more-item-filter mob_icon_filter opens_filter" : "ribbon select_style mob_select_style more-item-filter mob_icon_filter down"} key="tlcMrFlt">
                <div className="filter_more" onClick={this.onMoreFilterClick}>
                    <span>{this.state.moreFilterState ? <i className="fa fa-caret-up" /> : <i className="fa fa-caret-down" />}</span> {/*<i className={this.state.moreFilterState ? "fa fa-angle-up" : "fa fa-angle-down"}></i>*/}
                </div>
            </li>);
        }

        var tlcMobileFilters = [];
        var tlcWindowFilters = [];
        if (window.innerWidth > 767) {
            tlcWindowFilters.push(tlcMinMaxFilter);
            tlcWindowFilters.push(tlcBedFilter);
            tlcWindowFilters.push(tlcBathFilter);
            //tlcWindowFilters.push(tlcPropertyTypeFilter);
        }
        else if (window.innerWidth === 768) {
            tlcMobileFilters.push(tlcMinMaxFilter);
            tlcMobileFilters.push(tlcBedFilter);
            tlcMobileFilters.push(tlcBathFilter);
            //tlcMobileFilters.push(tlcPropertyTypeFilter);
        }
        tlcWindowFilters.push(tlcMoreFilter);
        //tlcWindowFilters.push(saveSearch);
        if (window.innerWidth > 767) {
            tlcWindowFilters.push(searchBtn);
            if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowResetButtonOnMainSearchBar){
                tlcWindowFilters.push(ResetBtn);
            }
            if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowSaveSearchButtonOnMainSearchBar){
                tlcWindowFilters.push(saveSearchMainBtn);
            }
        }

        var moreFilterHeight = {};
        var moreFilterInnerHeight = {};        
        
        var advanceFiltersHeight = {};
        var ht = 0;
        ht = ht + ((ThemeCustomizationOptions && ThemeCustomizationOptions.MainMenuBarClass === "menu-large") ? 106 : 66);
        ht = ht + ((ThemeCustomizationOptions && ThemeCustomizationOptions.MainSearchBarClass === "compact-search") ? 54 : 63);
        if(window.innerWidth <= 767){
            if(!this.props.isAnonymous){
                ht = ht + 30;
            }
        }
        advanceFiltersHeight = {maxHeight: (window.innerHeight - ht), overflowY: "auto" , overflowX: "hidden"};
        
        const recentSearches = this.state.recentSearches.slice().reverse();
        const locationDisabled = this.props.geolocation && this.props.geolocation.error;

        /* var tlcGarageFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcGarage">
                <Select
                    placeholder="Garage size"
                    name="garages"
                    className={(this.props.searchParameters_Redux.garages && this.props.searchParameters_Redux.garages !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Garage size" }].concat(getGarages()), this.props.searchParameters_Redux.garages, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'garages')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Garage size" }].concat(getGarages()))}
                />
            </div>
        ); */
        /* var tlcSquareFeetFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcSquareFeet">
                <Select
                    placeholder="Square feet"
                    name="livingareamin"
                    className={(this.props.searchParameters_Redux.livingareamin && this.props.searchParameters_Redux.livingareamin !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Square feet" }].concat(getHomeSizes()), this.props.searchParameters_Redux.livingareamin, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'livingareamin')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Square feet" }].concat(getHomeSizes()))}
                />
            </div>
        ); */
        /* var tlcLotSizeFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcLotSize">
                <Select
                    placeholder="Lot size"
                    name="acresmin"
                    className={(this.props.searchParameters_Redux.acresmin && this.props.searchParameters_Redux.acresmin !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Lot size" }].concat(getLotSizes()), this.props.searchParameters_Redux.acresmin, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'acresmin')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Lot size" }].concat(getLotSizes()))}
                />
            </div>
        ); */
        /* var tlcHomeAgeFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcHomeAge">
                <Select
                    placeholder="Year built"
                    name="yearbuiltmin"
                    className={(this.props.searchParameters_Redux.yearbuiltmin && this.props.searchParameters_Redux.yearbuiltmin !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Year built" }].concat(getBuiltYears()), this.props.searchParameters_Redux.yearbuiltmin, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'yearbuiltmin')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Year built" }].concat(getBuiltYears()))}
                />
            </div>
        ); */
        /* var homeStyleOptions = [];
        homeStyleOptions = getFormattedOptions(getPropertyTypes());
        
        var tlcHomeStyleFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcPropType">
                {<SelectBox
                    label="Home style"
                    multiple="true"
                    className={(this.props.searchParameters_Redux.propertytype && this.props.searchParameters_Redux.propertytype !== "") ? "dropdown tru-dropdown square selected" : "dropdown tru-dropdown square"}
                    value={this.props.searchParameters_Redux.propertytype}
                    onChange={this.handlePropertyTypeChange}>
                    {homeStyleOptions}
                </SelectBox>}
            </div>
        ); */
        /* var tlcBasementFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="basement_check" type="checkbox" name="hasbasement" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasbasement) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasbasement === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Basement</div>
            </div>
        ); */
        /* var tlcFireplaceFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="fireplace_check" type="checkbox" name="hasfireplace" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasfireplace) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasfireplace === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Fireplace</div>
            </div>
        ); */
        /* var tlcWaterfrontFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="Waterfront_check" type="checkbox" name="haswaterfront" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.haswaterfront) ? "true" : "false"} checked={(this.props.searchParameters_Redux.haswaterfront === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Waterfront</div>
            </div>
        ); */
        /* var tlcWaterviewFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="waterview_check" type="checkbox" name="haswaterview" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.haswaterview) ? "true" : "false"} checked={(this.props.searchParameters_Redux.haswaterview === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Waterview</div>
            </div>
        ); */
        /* var tlcPoolFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="pool_true" type="checkbox" name="haspool_chkyes" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.haspool === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux.haspool === "true") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check"><span></span></span>
                </label>
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="pool_false" type="checkbox" name="haspool_chkno" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.haspool === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux.haspool === "false") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                </label>
                <div className="tru-checkbok-name">Pool</div>
            </div>
        ); */
        /* var tlcShortSaleFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="short_true" type="checkbox" name="isshortsale_chkyes" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.isshortsale === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux.isshortsale === "true") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check"><span></span></span>
                </label>
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="short_false" type="checkbox" name="isshortsale_chkno" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.isshortsale === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux.isshortsale === "false") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                </label>
                <div className="tru-checkbok-name">Short sale</div>
            </div>
        ); */
        /* var tlcOpenhouseFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="open_house" type="checkbox" name="openHouseOnly" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.openHouseOnly) ? "true" : "false"} checked={(this.props.searchParameters_Redux.openHouseOnly === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Open house</div>
            </div>
        ); */
        /* var tlcHoaFeeFilter = (
            <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcHoaFee">
                <Select
                    placeholder={window.innerWidth < 768 ? "Max HOA Fee" : "Max monthly HOA fee"}
                    name="hoafeemax"
                    className={(this.props.searchParameters_Redux.hoafeemax && this.props.searchParameters_Redux.hoafeemax !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: window.innerWidth < 768 ? "Max HOA Fee" : "Max monthly HOA fee" }].concat(getMaxHOAFees()), this.props.searchParameters_Redux.hoafeemax, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'hoafeemax')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: window.innerWidth < 768 ? "Max HOA Fee" : "Max monthly HOA fee" }].concat(getMaxHOAFees()))}
                />
            </div>
        ); */
        /* var tlcStatusFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcStatusFilter">
                <SelectBox
                    label={"Status"}
                    className={"dropdown tru-dropdown square selected"}
                    value={(this.props.searchParameters_Redux.status) ? this.props.searchParameters_Redux.status : "Active"}
                    onChange={(v) => this.handleSelectValueChange('status', v)}>
                    {getFormattedOptions(getSearchStatuses())}
                </SelectBox>
            </div>
        ); */
        /* var tlcWaterFrontTypeFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcWaterFrontTypeFilter">
                <SelectBox
                    label={"Water Front Type"}
                    className={(this.props.searchParameters_Redux.waterfeatures && this.props.searchParameters_Redux.waterfeatures !== "") ? "dropdown tru-dropdown square selected" : "dropdown tru-dropdown square"}
                    value={(this.props.searchParameters_Redux.waterfeatures) ? this.props.searchParameters_Redux.waterfeatures : ""}
                    onChange={(v) => this.handleSelectValueChange('waterfeatures', v)}>
                    {getFormattedOptions([{ value: "", text: "Water Front Type" }].concat(getWaterFrontTypes()))}
                </SelectBox>
            </div>
        ); */
        /* var tlcBankOwnedFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="isbankowned_true" type="checkbox" name="isbankowned_chkyes" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.isbankowned === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux.isbankowned === "true") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check"><span></span></span>
                </label>
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="isbankowned_false" type="checkbox" name="isbankowned_chkno" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.isbankowned === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux.isbankowned === "false") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                </label>
                <div className="tru-checkbok-name">Bank Owned</div>
            </div>
        ); */
        /* var tlcWaterAccessFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="haswateraccess_true" type="checkbox" name="haswateraccess_chkyes" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.haswateraccess === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux.haswateraccess === "true") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check"><span></span></span>
                </label>
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="haswateraccess_false" type="checkbox" name="haswateraccess_chkno" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.haswateraccess === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux.haswateraccess === "false") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                </label>
                <div className="tru-checkbok-name">Water Access</div>
            </div>
        ); */
        /* var tlcGolfCourseFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="hasgolfcourse_true" type="checkbox" name="hasgolfcourse_chkyes" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.hasgolfcourse === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasgolfcourse === "true") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check"><span></span></span>
                </label>
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="hasgolfcourse_false" type="checkbox" name="hasgolfcourse_chkno" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.hasgolfcourse === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasgolfcourse === "false") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                </label>
                <div className="tru-checkbok-name">Golf Course</div>
            </div>
        ); */
        /* var tlcGreenFeaturesFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="hasgreenfeatures_true" type="checkbox" name="hasgreenfeatures_chkyes" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.hasgreenfeatures === "true") ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasgreenfeatures === "true") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check"><span></span></span>
                </label>
                <label className="tru-checkbox-gray joint-checkbox">
                    <input id="hasgreenfeatures_false" type="checkbox" name="hasgreenfeatures_chkno" onChange={this.onJointCheckChange} value={(this.props.searchParameters_Redux.hasgreenfeatures === "false") ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasgreenfeatures === "false") ? "checked" : ""} />
                    <span className="tru-checkbox-gray_check tru-checkbox-gray_check_close"><span></span></span>
                </label>
                <div className="tru-checkbok-name">Green Features</div>
            </div>
        ); */
        /* var tlcDprFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="dpr_check" type="checkbox" name="dpr" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.haswaterview) ? "true" : "false"} checked={(this.props.searchParameters_Redux.dpr === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Downpayment Assistance</div>
            </div>
        ); */
        /* var tlcKeywordsFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcKeywordsFilter">
                <div>
                    <input type="text"
                        ref={(ref) => this.keywordsRef = ref}
                        name="keywords"
                        placeholder="Keywords"
                        className={(this.props.searchParameters_Redux.keywords && this.props.searchParameters_Redux.keywords !== "") ? "form-control textbox textbox-large selected" : "form-control textbox textbox-large"}
                        defaultValue={(this.props.searchParameters_Redux.keywords) ? this.props.searchParameters_Redux.keywords : ""}
                        onKeyDown={this.handleTextKeyDown}
                        onBlur={this.handleTextBlur} />
                </div>
            </div>
        ); */
        /* var tlcGymFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="hasgym_check" type="checkbox" name="hasgym" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasgym) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasgym === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Gym</div>
            </div>
        ); */
        /* var tlcCentralACFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="hascentralac_check" type="checkbox" name="hascentralac" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hascentralac) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hascentralac === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Central A/C</div>
            </div>
        ); */
        /* var tlcDoormanFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="hasdoorman_check" type="checkbox" name="hasdoorman" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasdoorman) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasdoorman === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Doorman</div>
            </div>
        ); */
        /* var tlcDishwasherFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="hasdishwasher_check" type="checkbox" name="hasdishwasher" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasdishwasher) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasdishwasher === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Dishwasher</div>
            </div>
        ); */
        /* var tlcBalconyFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="hasbalcony_check" type="checkbox" name="hasbalcony" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasbalcony) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasbalcony === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Balcony</div>
            </div>
        ); */
        /* var tlcRoofAccessFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="hasroofaccess_check" type="checkbox" name="hasroofaccess" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.hasroofaccess) ? "true" : "false"} checked={(this.props.searchParameters_Redux.hasroofaccess === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Roof Access</div>
            </div>
        ); */
        /* var tlcKeylessEntryFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="haskeylessentry_check" type="checkbox" name="haskeylessentry" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.haskeylessentry) ? "true" : "false"} checked={(this.props.searchParameters_Redux.haskeylessentry === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Keyless Entry</div>
            </div>
        ); */
        /* var tlcNeighborhoodFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcNeighborhoodFilter">
                <Select
                    placeholder="Neighborhood"
                    name="neighborhood"
                    isMulti={true}
                    className={(this.props.searchParameters_Redux.neighborhood && this.props.searchParameters_Redux.neighborhood !== "" && this.props.searchParameters_Redux.neighborhood.length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    styles={{
                        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                            const fBold = (data.label.indexOf(' County') >= 0) ? "bold" : "inherit";
                            return {
                              ...styles,
                              fontWeight: isDisabled
                                ? null
                                : fBold,                                                  
                            };
                        }
                    }}
                    value={getFormattedValueForReactSelect(this.getNeighborhoodNames(), this.props.searchParameters_Redux.neighborhood, true)}
                    onChange={(e) => this.handleReactSelectChange(e, 'neighborhood')}
                    options={getFormattedOptionsForReactSelect(this.getNeighborhoodNames())}
                />
            </div>
        ); */
        /* var tlcSchoolDistrictFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcSchoolDistrictFilter">
                <Select
                    placeholder="School District"
                    name="schooldistrictname"
                    className={(this.props.searchParameters_Redux.schooldistrictname && this.props.searchParameters_Redux.schooldistrictname !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect(this.getSchoolDistrictNames(), this.props.searchParameters_Redux.schooldistrictname, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'schooldistrictname')}
                    options={getFormattedOptionsForReactSelect(this.getSchoolDistrictNames())}
                />
            </div>
        ); */
        /* var tlcRegionalBoardCodeRochesterFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="regionalboardcode_check" type="checkbox" name="regionalboardcode" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.regionalboardcode && this.props.searchParameters_Redux.regionalboardcode.indexOf("rochester") >= 0) ? "true" : "false"} checked={(this.props.searchParameters_Redux.regionalboardcode && this.props.searchParameters_Redux.regionalboardcode.indexOf("rochester") >= 0) ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Include Rochester</div>
            </div>
        ); */
        /* var tlcFarmLandFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="farmland_check" type="checkbox" name="isfarmland" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.isfarmland) ? "true" : "false"} checked={(this.props.searchParameters_Redux.isfarmland === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Farm Land</div>
            </div>
        ); */
        /* var tlcNewConstructionFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="newconstruction_check" type="checkbox" name="isnewconstruction" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.isnewconstruction) ? "true" : "false"} checked={(this.props.searchParameters_Redux.isnewconstruction === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">New Construction</div>
            </div>
        ); */
        /* var tlcForeclosureFilter = (
            <div className="tru-checkbox-area mg-top-12">
                <label className="tru-checkbox">
                    <input id="foreclosure_check" type="checkbox" name="isforeclosure" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.isforeclosure) ? "true" : "false"} checked={(this.props.searchParameters_Redux.isforeclosure === "true") ? "checked" : ""} />
                    <span className="tru-checkbox_checkmark"></span>
                </label>
                <div className="tru-checkbok-name">Foreclosure</div>
            </div>
        ); */
        /* var tlcStoriesFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcStoriesFilter">
                <Select
                    placeholder="Stories"
                    name="stories"
                    className={(this.props.searchParameters_Redux.stories && this.props.searchParameters_Redux.stories !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Stories" }].concat(getStories()), this.props.searchParameters_Redux.stories, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'stories')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Stories" }].concat(getStories()))}
                />
            </div>
        ); */
        /* var tlcCondoTypeFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcCondoTypeFilter">
                <Select
                    placeholder="Condo Type"
                    name="condotype"
                    className={(this.props.searchParameters_Redux.condotype && this.props.searchParameters_Redux.condotype !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Condo Type" }].concat(getCondoTypes()), this.props.searchParameters_Redux.condotype, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'condotype')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Condo Type" }].concat(getCondoTypes()))}
                />
            </div>
        ); */
        /* var tlcLotFeatureFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcLotFeatureFilter">
                <Select
                    placeholder="Lot Feature"
                    name="lotfeature"
                    isMulti={true}
                    className={(this.props.searchParameters_Redux.lotfeature && this.props.searchParameters_Redux.lotfeature !== "" && this.props.searchParameters_Redux.lotfeature.length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect(getLotFeatures(), this.props.searchParameters_Redux.lotfeature, true)}
                    onChange={(e) => this.handleReactSelectChange(e, 'lotfeature')}
                    options={getFormattedOptionsForReactSelect(getLotFeatures())}
                />
            </div>
        ); */
        /* var tlcStyleFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcStyleFilter">
                <Select
                    placeholder="Style"
                    name="propertystyle"
                    isMulti={true}
                    className={(this.props.searchParameters_Redux.propertystyle && this.props.searchParameters_Redux.propertystyle !== "" && this.props.searchParameters_Redux.propertystyle.length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect(getPropertyStyles(), this.props.searchParameters_Redux.propertystyle, true)}
                    onChange={(e) => this.handleReactSelectChange(e, 'propertystyle')}
                    options={getFormattedOptionsForReactSelect(getPropertyStyles())}
                />
            </div>
        ); */
        /* var tlcRoomsFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcRoomsFilter">
                <Select
                    placeholder="Rooms"
                    name="roompref"
                    isMulti={true}
                    className={(this.props.searchParameters_Redux.roompref && this.props.searchParameters_Redux.roompref !== "" && this.props.searchParameters_Redux.roompref.length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect(getRooms(), this.props.searchParameters_Redux.roompref, true)}
                    onChange={(e) => this.handleReactSelectChange(e, 'roompref')}
                    options={getFormattedOptionsForReactSelect(getRooms())}
                />
            </div>
        ); */
        /* var tlcAccessibilityFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcAccessibilityFilter">
                <Select
                    placeholder="Accessibility"
                    name="accessibility"
                    isMulti={true}
                    className={(this.props.searchParameters_Redux.accessibility && this.props.searchParameters_Redux.accessibility !== "" && this.props.searchParameters_Redux.accessibility.length > 0) ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect(getAccessibilities(), this.props.searchParameters_Redux.accessibility, true)}
                    onChange={(e) => this.handleReactSelectChange(e, 'accessibility')}
                    options={getFormattedOptionsForReactSelect(getAccessibilities())}
                />
            </div>
        ); */
        /* var tlcPostalCodeFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcPostalCodeFilter">
                <div>
                    <input type="text"
                        ref={(ref) => this.postalCodeRef = ref}
                        name="postalcode"
                        placeholder="Zip Codes (Ex. 14226,14227)"
                        className={(this.props.searchParameters_Redux.postalcode && this.props.searchParameters_Redux.postalcode !== "") ? "form-control textbox textbox-large selected" : "form-control textbox textbox-large"}
                        defaultValue={(this.props.searchParameters_Redux.postalcode) ? this.props.searchParameters_Redux.postalcode : ""}
                        onKeyDown={this.handleTextKeyDown}
                        onBlur={this.handleTextBlur} />
                </div>
            </div>
        ); */
        /* var tlcEntryDaysFilter = (
            <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcEntryDaysFilter">
                <Select
                    placeholder="Show All Listings"
                    name="entrydayold"
                    className={(this.props.searchParameters_Redux.entrydayold && this.props.searchParameters_Redux.entrydayold !== "") ? "tru-dropdown-compact react-select-container square selected" : "tru-dropdown-compact react-select-container square"}
                    classNamePrefix="react-select"
                    value={getFormattedValueForReactSelect([{ value: "", text: "Show All Listings" }].concat(getEntryDays()), this.props.searchParameters_Redux.entrydayold, false)}
                    onChange={(e) => this.handleReactSelectChange(e, 'entrydayold')}
                    options={getFormattedOptionsForReactSelect([{ value: "", text: "Show All Listings" }].concat(getEntryDays()))}
                />
            </div>
        ); */
        var tlcAdvancedFilters = [];
        //if (window.innerWidth > 768) {
            //tlcAdvancedFilters.push(tlcEntryDaysFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-6 col-sm-6 col-xs-12 form-group" key="tlcCheckFilters">
                    <div className="row">
                        <div className="col-md-4 col-sm-4 col-xs-12" key="tlcRegionalBoardCodeRochesterFilter">
                            {tlcRegionalBoardCodeRochesterFilter}
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-12" key="tlcNewConstruction">
                            {tlcNewConstructionFilter}
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-12" key="tlcForeclosure">
                            {tlcForeclosureFilter}
                        </div>
                    </div>
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcFarmOpen">
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">{tlcFarmLandFilter}</div>
                        <div className="col-sm-6 col-xs-12" style={window.innerWidth === 1024 ? { paddingLeft: 0 } : {}}>{tlcOpenhouseFilter}</div>
                    </div>
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcHomeStyleFilter);
            //tlcAdvancedFilters.push(tlcStoriesFilter);
            //tlcAdvancedFilters.push(tlcLotFeatureFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWftWvw">
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">{tlcWaterfrontFilter}</div>
                        <div className="col-sm-6 col-xs-12">{tlcWaterviewFilter}</div>
                    </div>
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcNeighborhoodFilter);
            //tlcAdvancedFilters.push(tlcStyleFilter);
            //tlcAdvancedFilters.push(tlcLotSizeFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBasFire">
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">{tlcBasementFilter}</div>
                        <div className="col-sm-6 col-xs-12">{tlcFireplaceFilter}</div>
                    </div>
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcSchoolDistrictFilter);
            //tlcAdvancedFilters.push(tlcRoomsFilter);
            //tlcAdvancedFilters.push(tlcAccessibilityFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcShortSale">
                    {tlcShortSaleFilter}
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcPostalCodeFilter);
            //tlcAdvancedFilters.push(tlcHomeAgeFilter);
            //tlcAdvancedFilters.push(tlcGarageFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcPool">
                    {tlcPoolFilter}
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcHoaFeeFilter);
            //tlcAdvancedFilters.push(tlcSquareFeetFilter);
            //tlcAdvancedFilters.push(tlcCondoTypeFilter);
            //tlcAdvancedFilters.push(includeCommuteControl);

            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.status) {
                tlcAdvancedFilters.push(tlcStatusFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.waterfeatures) {
                tlcAdvancedFilters.push(tlcWaterFrontTypeFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.isbankowned) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBankOwnedFilter">
                        {tlcBankOwnedFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.haswateraccess) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWaterAccessFilter">
                        {tlcWaterAccessFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.hasgolfcourse) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcGolfCourseFilter">
                        {tlcGolfCourseFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.hasgreenfeatures) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcGreenFeaturesFilter">
                        {tlcGreenFeaturesFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.dpr) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcDprFilter">
                        {tlcDprFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.keywords) {
                tlcAdvancedFilters.push(tlcKeywordsFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.gym) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcGymFilter">
                        {tlcGymFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.centralac) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcCentralACFilter">
                        {tlcCentralACFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.doorman) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcDoormanFilter">
                        {tlcDoormanFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.dishwasher) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcDishwasherFilter">
                        {tlcDishwasherFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.balcony) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBalconyFilter">
                        {tlcBalconyFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.roofaccess) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcRoofAccessFilter">
                        {tlcRoofAccessFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.keylessentry) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcKeylessEntryFilter">
                        {tlcKeylessEntryFilter}
                    </div>
                );
            } */

            /* if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.length > 0){
                var dFlts = SearchPageCustomizationOptions.SearchFilters.filter(f => f.Device === "desktop");
                if(dFlts && dFlts.length > 0 && dFlts[0].Params && dFlts[0].Params.length > 0){
                    dFlts[0].Params.map((f, i) => {
                        if(f && f.Params && f.Params.length > 0){
                            var ffArr = [];
                            f.Params.map((ff, j) => {                                
                                ffArr.push(this.getControl(ff));
                                return null;
                            });
                            if(ffArr && ffArr.length > 0){
                                tlcAdvancedFilters.push(
                                    <div className={f.Class} key={i}>
                                        <div className="row">{ffArr}</div>
                                    </div>
                                );
                            }
                        }
                        else{
                            tlcAdvancedFilters.push(this.getControl(f));
                        }
                        return null;
                    });
                }
            } */

        //}
        //else if (window.innerWidth === 768) {

            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcRegionalBoardCodeRochesterFilter">
                    {tlcRegionalBoardCodeRochesterFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcNewConstruction">
                    {tlcNewConstructionFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcForeclosure">
                    {tlcForeclosureFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcFarmLand">
                    {tlcFarmLandFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcOpenhouse">
                    {tlcOpenhouseFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWaterfront">
                    {tlcWaterfrontFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWaterview">
                    {tlcWaterviewFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBasement">
                    {tlcBasementFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcFireplace">
                    {tlcFireplaceFilter}
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcEntryDaysFilter);
            //tlcAdvancedFilters.push(tlcHomeStyleFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcShortSale">
                    {tlcShortSaleFilter}
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcNeighborhoodFilter);
            //tlcAdvancedFilters.push(tlcStoriesFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcPool">
                    {tlcPoolFilter}
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcSchoolDistrictFilter);
            //tlcAdvancedFilters.push(tlcStyleFilter);
            //tlcAdvancedFilters.push(tlcRoomsFilter);
            //tlcAdvancedFilters.push(tlcAccessibilityFilter);
            //tlcAdvancedFilters.push(tlcLotFeatureFilter);
            //tlcAdvancedFilters.push(tlcLotSizeFilter);
            //tlcAdvancedFilters.push(includeCommuteControl);
            //tlcAdvancedFilters.push(tlcPostalCodeFilter);
            //tlcAdvancedFilters.push(tlcHomeAgeFilter);
            //tlcAdvancedFilters.push(tlcGarageFilter);
            //tlcAdvancedFilters.push(tlcHoaFeeFilter);
            //tlcAdvancedFilters.push(tlcSquareFeetFilter);
            //tlcAdvancedFilters.push(tlcCondoTypeFilter);

            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.status) {
                tlcAdvancedFilters.push(tlcStatusFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.waterfeatures) {
                tlcAdvancedFilters.push(tlcWaterFrontTypeFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.isbankowned) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBankOwnedFilter">
                        {tlcBankOwnedFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.haswateraccess) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWaterAccessFilter">
                        {tlcWaterAccessFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.hasgolfcourse) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcGolfCourseFilter">
                        {tlcGolfCourseFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.hasgreenfeatures) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcGreenFeaturesFilter">
                        {tlcGreenFeaturesFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.dpr) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcDprFilter">
                        {tlcDprFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.keywords) {
                tlcAdvancedFilters.push(tlcKeywordsFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.gym) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcGymFilter">
                        {tlcGymFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.centralac) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcCentralACFilter">
                        {tlcCentralACFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.doorman) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcDoormanFilter">
                        {tlcDoormanFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.dishwasher) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcDishwasherFilter">
                        {tlcDishwasherFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.balcony) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBalconyFilter">
                        {tlcBalconyFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.roofaccess) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcRoofAccessFilter">
                        {tlcRoofAccessFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.keylessentry) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcKeylessEntryFilter">
                        {tlcKeylessEntryFilter}
                    </div>
                );
            } */

            /* if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.length > 0){
                var dFlts = SearchPageCustomizationOptions.SearchFilters.filter(f => f.Device === "ipad");
                if(dFlts && dFlts.length > 0 && dFlts[0].Params && dFlts[0].Params.length > 0){
                    dFlts[0].Params.map((f, i) => {
                        if(f && f.Params && f.Params.length > 0){
                            var ffArr = [];
                            f.Params.map((ff, j) => {                                
                                ffArr.push(this.getControl(ff));
                                return null;
                            });
                            if(ffArr && ffArr.length > 0){
                                tlcAdvancedFilters.push(
                                    <div className={f.Class} key={i}>
                                        <div className="row">{ffArr}</div>
                                    </div>
                                );
                            }
                        }
                        else{
                            tlcAdvancedFilters.push(this.getControl(f));
                        }
                        return null;
                    });
                }
            } */

        //}
        //else {
            //tlcAdvancedFilters.push(tlcEntryDaysFilter);
            //tlcAdvancedFilters.push(tlcHomeStyleFilter);            
            //tlcAdvancedFilters.push(tlcBedFilter);
            //tlcAdvancedFilters.push(tlcBathFilter);
            //tlcAdvancedFilters.push(tlcNeighborhoodFilter);
            //tlcAdvancedFilters.push(tlcSchoolDistrictFilter);
            //tlcAdvancedFilters.push(tlcPostalCodeFilter);
            //tlcAdvancedFilters.push(tlcMinMaxFilter);            
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcRegionalBoardCodeRochesterFilter">
                    {tlcRegionalBoardCodeRochesterFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcNewConstruction">
                    {tlcNewConstructionFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcForeclosure">
                    {tlcForeclosureFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcFarmLand">
                    {tlcFarmLandFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcOpenhouse">
                    {tlcOpenhouseFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWaterfront">
                    {tlcWaterfrontFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcWaterview">
                    {tlcWaterviewFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcBasement">
                    {tlcBasementFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcFireplace">
                    {tlcFireplaceFilter}
                </div>
            ); */
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcPool">
                    {tlcPoolFilter}
                </div>
            ); */
            //tlcAdvancedFilters.push(tlcHoaFeeFilter);
            /* tlcAdvancedFilters.push(
                <div className="col-md-3 col-sm-4 col-xs-6 form-group" key="tlcShortSale">
                    {tlcShortSaleFilter}
                </div>
            ); */            
            
            //tlcAdvancedFilters.push(tlcStoriesFilter);
            //tlcAdvancedFilters.push(tlcStyleFilter);
            //tlcAdvancedFilters.push(tlcRoomsFilter);
            //tlcAdvancedFilters.push(tlcAccessibilityFilter);
            //tlcAdvancedFilters.push(tlcLotFeatureFilter);
            //tlcAdvancedFilters.push(tlcLotSizeFilter);            
            
            //tlcAdvancedFilters.push(tlcHomeAgeFilter);
            //tlcAdvancedFilters.push(tlcGarageFilter);
            //tlcAdvancedFilters.push(tlcSquareFeetFilter);
            //tlcAdvancedFilters.push(tlcCondoTypeFilter);
            //tlcAdvancedFilters.push(includeCommuteControl);

            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.status) {
                tlcAdvancedFilters.push(tlcStatusFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.waterfeatures) {
                tlcAdvancedFilters.push(tlcWaterFrontTypeFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.isbankowned) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcBankOwnedFilter">
                        {tlcBankOwnedFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.haswateraccess) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcWaterAccessFilter">
                        {tlcWaterAccessFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.hasgolfcourse) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcGolfCourseFilter">
                        {tlcGolfCourseFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.hasgreenfeatures) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcGreenFeaturesFilter">
                        {tlcGreenFeaturesFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.dpr) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcDprFilter">
                        {tlcDprFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.keywords) {
                tlcAdvancedFilters.push(tlcKeywordsFilter);
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.gym) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcGymFilter">
                        {tlcGymFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.centralac) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcCentralACFilter">
                        {tlcCentralACFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.doorman) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcDoormanFilter">
                        {tlcDoormanFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.dishwasher) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcDishwasherFilter">
                        {tlcDishwasherFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.balcony) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcBalconyFilter">
                        {tlcBalconyFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.roofaccess) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcRoofAccessFilter">
                        {tlcRoofAccessFilter}
                    </div>
                );
            } */
            /* if (SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.keylessentry) {
                tlcAdvancedFilters.push(
                    <div className="col-md-3 col-sm-4 col-xs-12 form-group" key="tlcKeylessEntryFilter">
                        {tlcKeylessEntryFilter}
                    </div>
                );
            } */ 
            
            /* if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.length > 0){
                var dFlts = SearchPageCustomizationOptions.SearchFilters.filter(f => f.Device === "mobile");
                if(dFlts && dFlts.length > 0 && dFlts[0].Params && dFlts[0].Params.length > 0){
                    dFlts[0].Params.map((f, i) => {
                        if(f && f.Name === "beds"){
                            tlcAdvancedFilters.push(tlcBedFilter);            
                        }
                        else if(f && f.Name === "baths"){
                            tlcAdvancedFilters.push(tlcBathFilter);
                        }
                        else if(f && f.Name === "tlcprice"){
                            tlcAdvancedFilters.push(tlcMinMaxFilter);
                        }
                        else{
                            if(f && f.Params && f.Params.length > 0){
                                var ffArr = [];
                                f.Params.map((ff, j) => {                                
                                    ffArr.push(this.getControl(ff));
                                    return null;
                                });
                                if(ffArr && ffArr.length > 0){
                                    tlcAdvancedFilters.push(
                                        <div className={f.Class} key={i}>
                                            <div className="row">{ffArr}</div>
                                        </div>
                                    );
                                }
                            }
                            else{
                                tlcAdvancedFilters.push(this.getControl(f));
                            }
                        }
                        return null;
                    });
                }
            } */
        //}

        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchFilters && SearchPageCustomizationOptions.SearchFilters.length > 0){
            var dFlts = SearchPageCustomizationOptions.SearchFilters.filter(f => f.Device === (window.innerWidth > 768 ? "desktop" : (window.innerWidth === 768 ? "ipad" : "mobile")));
            if(dFlts && dFlts.length > 0 && dFlts[0].Params && dFlts[0].Params.length > 0){
                dFlts[0].Params.map((f, i) => {
                    if(window.innerWidth < 768 && f && f.Name === "beds"){
                        tlcAdvancedFilters.push(tlcBedFilter);            
                    }
                    else if(window.innerWidth < 768 && f && f.Name === "baths"){
                        tlcAdvancedFilters.push(tlcBathFilter);
                    }
                    else if(window.innerWidth < 768 && f && f.Name === "tlcprice"){
                        tlcAdvancedFilters.push(tlcMinMaxFilter);
                    }
                    else if(f){
                        if(f && f.Params && f.Params.length > 0){
                            var ffArr = [];
                            f.Params.map((ff, j) => {                                
                                ffArr.push(this.getControl(ff));
                                return null;
                            });
                            if(ffArr && ffArr.length > 0){
                                tlcAdvancedFilters.push(
                                    <div className={f.Class} key={i}>
                                        <div className="row">{ffArr}</div>
                                    </div>
                                );
                            }
                        }
                        else{
                            tlcAdvancedFilters.push(this.getControl(f));
                        }
                    }
                    return null;
                });
            }
        }

        return (
            <section className={(ThemeCustomizationOptions && ThemeCustomizationOptions.MainSearchBarClass && ThemeCustomizationOptions.MainSearchBarClass !== "") ? "Searchbar search-bar-fixed " + ThemeCustomizationOptions.MainSearchBarClass : "Searchbar search-bar-fixed"} ref="searchBarRef">
                <ReactTooltip />
                <div className="bg-overlay white padding-0">
                    <div className="Searchbar-content fluid row border-left-gray search-extrabtn">
                        <div className="col-md-12 col-sm-12 col-xs-12 remove_pad">
                            <div className={(this.state.locationText && this.state.locationText !== "") ? "input-search-top active search-item-location pd-top-15 pd-bot-15 selected" : "input-search-top active search-item-location pd-top-15 pd-bot-15"}>
                                <div className={this.state.mSearchExpanded ? "top_search_box show" : "top_search_box"}>
                                    <div className="input-group">
                                        <SuperAutoComplete
                                            ref={ref => this.esriAutoComplete = ref}
                                            id="sacLocation"
                                            className="search"
                                            placeholder={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCPlaceholder) ? SearchPageCustomizationOptions.LocationSCPlaceholder : "Street, City, Zip or MLS#"}
                                            IncludeMLSNumber={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludeMLSNumber) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludeMLSNumber) : 0}
                                            IncludeStreetAddress={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludeStreetAddress) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludeStreetAddress) : 1}
                                            IncludeCity={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludeCity) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludeCity) : 0}
                                            IncludePostal={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludePostal) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludePostal) : 1}
                                            IncludeTown={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludeTown) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludeTown) : 0}
                                            IncludeCounty={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludeCounty) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludeCounty) : 0}
                                            IncludeVillage={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCIncludeVillage) ? parseInt(SearchPageCustomizationOptions.LocationSCIncludeVillage) : 0}
                                            ReturnMLSNumber={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.LocationSCReturnMLSNumber) ? parseInt(SearchPageCustomizationOptions.LocationSCReturnMLSNumber) : 0}
                                            RegionalBoardCode={(this.props.searchParameters_Redux && this.props.searchParameters_Redux.regionalboardcode && this.props.searchParameters_Redux.regionalboardcode !== "") ? this.props.searchParameters_Redux.regionalboardcode : null}
                                            //FilterPropertyType={(this.props.searchParameters_Redux && this.props.searchParameters_Redux.propertytype && this.props.searchParameters_Redux.propertytype !== "") ? (Array.isArray(this.props.searchParameters_Redux.propertytype) ? this.props.searchParameters_Redux.propertytype.join(',') : this.props.searchParameters_Redux.propertytype) : null}                                            
                                            hideFocus={true}
                                            defaultSelected={this.state.locationText}
                                            handleAutoComplete={this.handleAutoComplete}
                                            onEnterPressed={this.autoCompleteEnterPressed}
                                            onInputChange={this.onLocationTextChange}
                                            onFocus={this.onFocus}
                                            onBlur={this.handleAutoCompleteBlur}
                                            recentSearchClicked={this.state.recentSearchClicked} />
                                    </div>
                                    {this.state.showNearbySearch &&
                                        <div className="location_nearby">
                                            {this.state.recentSearches.length > 0 &&
                                                <div className="recent_search">
                                                    <div className="recent_icon"><i className="fa fa-clock-o"></i></div>
                                                    <div className="recent_location">
                                                        <div className="item_sub_title">Most recent search</div>
                                                        {recentSearches.map((search, i) => {
                                                            return <div key={i} onMouseDown={() => this.handleAutoComplete(search)} className="location_city">{search}</div>
                                                        })}
                                                    </div>
                                                </div>
                                            }
                                            <div className="recent_search">
                                                <ReactTooltip />
                                                <div className="recent_icon"><i className="fa fa-paper-plane"></i></div>
                                                <div className="recent_location">
                                                    <div className="item_sub_title">Nearby</div>
                                                    <div className="nearby_item">
                                                        <div style={{ float: "left", marginRight: "5px" }} data-class="tooltip_box" data-tip={locationDisabled ? 'You must enable browser location' : ''}> {/* don't remove this div....button stops working */}
                                                            <button disabled={locationDisabled} onMouseDown={(e) => this.getGeoLocation(e)} className="icon_box" id="nearby_sale">
                                                                <span style={{ padding: '5px 5px 5px 5px', display: 'block' }}>For sale</span>
                                                            </button>
                                                        </div>
                                                        <div data-class="tooltip_box" data-tip={locationDisabled ? 'You must enable browser location' : ''}>
                                                            <button disabled={locationDisabled} onMouseDown={(e) => this.getGeoOpenHouses(e)} className="icon_box" id="nearby_open_houses">
                                                                <span id="openHouses" style={{ padding: '5px 5px 5px 5px', display: 'block' }}>Open houses</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.askGeoLocation &&
                                                <GeoLocation />
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <ul className="breadcrumd find_filter small_bed_bath">
                                {tlcWindowFilters}
                            </ul>
                            <div className="pull-right mb_show_map mobile_toggle_icon">
                                <ToggleButton
                                    off={<i className="fa fa-map-marker" />}
                                    on={<i className="fa fa-list-ul" />}
                                    width="40px"
                                    height="64px"
                                    onstyle="warning"
                                    offstyle="warning"
                                    size="xs"
                                    active={this.state.showMap || false}
                                    onClick={this.onChangeView} />
                            </div>                            
                        </div>
                    </div>
                </div>
                <div className={moreFilterClass} style={(moreFilterClass.indexOf("show_filter") !== -1) ? moreFilterHeight : null} >
                    <div className="black_bg" onClick={this.onMoreFilterClick}></div>
                    <div className="filter_sub_bg" style={advanceFiltersHeight}>
                        <div id="filter_close" className="filter_close hidden-xs" onClick={this.onMoreFilterClick}><i className="icon-xout"></i></div>
                        <div className="fluid row">
                            <div className="filter_content" style={((window.innerWidth <= 767 || window.innerWidth === 812 || window.innerWidth === 823 || window.innerHeight < 680) && moreFilterClass.indexOf("show_filter") !== -1) ? moreFilterInnerHeight : null}>
                                <div className="row">
                                    {tlcMobileFilters}
                                    {tlcAdvancedFilters}

                                    <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                                        <div className="pd-top-10 pd-bot-10" style={{background: "#f0f0f0"}}>
                                            <span className="matching-listing-number">{(this.props.propCountLabel && this.props.propCountLabel !== "") ? this.props.propCountLabel : "No Matching Listings"}</span>                                            
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <div className="filter_matches" id="show_results">
                                            {saveSearchMoreBtn}
                                            <button id="reset_filters" onClick={this.resetSearch} className="mg-rt-20 mb-mg-rt-5 tru-btn tru-btn-big tru-btn-default resize_btn">
                                                {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ResetButtonTextInAdvanced && SearchPageCustomizationOptions.ResetButtonTextInAdvanced !== "") ? SearchPageCustomizationOptions.ResetButtonTextInAdvanced : "Reset Filters"}
                                            </button>
                                            {(this.state.fetchingResult) ?
                                                (<button className="tru-btn tru-btn-big tru-btn-default resize_btn">                                                    
                                                    {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.SearchButtonProcessingTextInAdvanced && SearchPageCustomizationOptions.SearchButtonProcessingTextInAdvanced !== "") ? SearchPageCustomizationOptions.SearchButtonProcessingTextInAdvanced : "Updating Search"}
                                                </button>)
                                                : 
                                                (<button className="tru-btn tru-btn-big tru-btn-default resize_btn" onClick={this.onMoreFilterClick}>                                                    
                                                    {(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ResetButtonTextInAdvanced && SearchPageCustomizationOptions.SearchButtonTextInAdvanced !== "") ? SearchPageCustomizationOptions.SearchButtonTextInAdvanced : "Find Homes"}
                                                </button>)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state, props) => ({
    audience: state.session.audience,
    purlPrefix: state.session.purlPrefix || { url: '' },
    isFetchingProfile: state.profile.isFetching,
    profile: state.profile.mine,
    clients: state.clients.ids.map(id => state.entities.clients[id]) || [],
    selectedClient: state.entities.clients[state.clients.selectedClient],
    isFetchingClients: state.clients.isFetching,
    searchParameters_Redux: state.search.parameters,
    geolocation: state.geolocation,
    isAnonymous: state.session.isAnonymous,
    schooldistrictnames: state.settings.schooldistrictnames || [],
    neighborhoods: state.settings.neighborhoods || []
});

const mapDispatchToProps = dispatch => ({
    searchActions: bindActionCreators(searchActions, dispatch),
    sessionActions: bindActionCreators(sessionActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
    settingActions: bindActionCreators(settingActions, dispatch),
    manageActions: bindActionCreators(manageActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
